import { LOCALES } from '../constants';
const es = {
  [LOCALES.ES]: {
    //All page
    "Página não encontrada": "Página no encontrada",
    //LOGIN
    "login.Login": "Inicio de sesión",
    "login.Informe seu e-mail": "Ingresa tu correo electrónico",
    "login.E-mail inválido. Por favor, verifique": "Correo electrónico no válido. Por favor, verifica.",
    "login.Senha": "Contraseña",
    "login.Sua senha deve possuir no mínimo 6 caracteres": "Tu contraseña debe tener al menos 6 caracteres.",
    "login.Permanecer conectado": "Permanecer conectado",
    "login.Esqueci minha senha": "Olvidé mi contraseña",
    "login.ENTRAR": "INGRESAR",
    "login.CRIAR CONTA": "CREAR CUENTA",
    "login.Não foi possÍvel fazer o login. Verifique seus dados e tente novamente": "No fue posible iniciar sesión. Verifica tus datos e intenta nuevamente.",
    "login.Solicitar Acesso": "Solicitar acceso",
    "login.Utilize esta opção caso possua apenas fornos da versão antiga, que não geram PIN.": "Utiliza esta opción en caso de que solo tengas hornos de versiones antiguas que no generan PIN.",
    "login.A PLATAFORMA IOK MUDOU!": "¡LA PLATAFORMA IOK HA CAMBIADO!",
    "login.Não exibir este aviso novamente": "No mostrar este aviso nuevamente.",
    "login.Se você já possui um cadastro na antiga plataforma,": "Si ya tienes un registro en la plataforma anterior,",
    "login.clique aqui": "haz clic aquí",
    "login. para migrar seus dados e aproveitar toda a experiência IOK.": "para migrar tus datos y disfrutar de la experiencia completa de IOK.",
    "login.Sua conta não foi ativada. Por gentileza, verifique seu e-mail para realizar a ativação": "Tu cuenta no ha sido activada. Por favor, verifica tu correo electrónico para activarla",
    "login.Para solicitar acesso a uma organização, o nome informado por você deve ser exatamente o mesmo cadastrado pelo administrador da conta. Em caso de dúvida, procure o responsável pela rede.": "Para solicitar acceso a una organización, el nombre que proporcionas debe ser exactamente el mismo que el registrado por el administrador de la cuenta. En caso de duda, busca la cadena responsable.",
    "login.Se você já possui um cadastro na antiga plataforma, ": "Si ya tienes un registro en la plataforma antigua, ",
    "login. para": " pour ",
    "login.migrar": "emigrar ",
    "login.seus dados e aproveitar toda a experiência IOK.": "tus datos y disfruta de toda la experiencia IOK.",
    "login.PLATAFORMA EM MANUTENÇÃO": "PLATAFORMA EN MANTENIMIENTO",
    "login.ESTAMOS PREPARANDO A NOVA PLATAFORMA IOK E EM BREVE ELA ESTARÁ PRONTA!": "¡ESTAMOS PREPARANDO LA NUEVA PLATAFORMA IOK Y PRONTO ESTARÁ LISTA!",
    "login.Migrar Conta": "Cuenta migrante",
    "login.Se você já possui um cadastro na antiga plataforma, clique aqui em Migrar Conta para migrar seus dados e aproveitar toda a experiência IOK": "Si ya tienes un registro en la plataforma anterior, haz clic aquí en Migrar Cuenta para migrar tus datos y disfrutar de toda la experiencia IOK",
    "login.Política de privacidade": "Política de privacidad",
    "login.ENTENDI": "ENTENDÍ",
    "login.Para melhorar a sua experiência na plataforma e oferecer serviços personalizados, utilizamos cookies.": "Utilizamos cookies para mejorar su experiencia en la plataforma y ofrecer servicios personalizados.",
    "login.Ao utilizar a Plataforma IOK, você automaticamente concorda com seu uso.": "Al utilizar la Plataforma IOK, automáticamente acepta su uso.",
    "login.Senha incorreta! Duas tentativas restantes antes de ter o acesso à conta bloqueado.": "¡Contraseña incorrecta! Quedan dos intentos antes de que se bloquee el acceso a la cuenta.",
    "login.Senha incorreta! Uma tentativa restantes antes de ter o acesso à conta bloqueado.": "¡Contraseña incorrecta! Queda un intento antes de que se bloquee el acceso a la cuenta.",
    "login.Acesso bloqueado! Siga as instruções de recuperação de conta.": "¡Acceso bloqueado! Siga las instrucciones de recuperación de cuenta.",
    
    //REGISTER
    "DISTRIBUIDOR": "DISTRIBUIDOR: Soy distribuidor de equipos de Prática.",
    "REDE": "RED: Soy dueño de una red.",
    "DONO": "EMPRESA: Soy dueño de mi propia empresa/soy parte de una red.",
    "register.Informe seu e-mail cadastrado na plataforma IOK anterior": "Ingresa tu correo electrónico registrado en la plataforma IOK anterior.",
    "register.E-mail inválido. Por favor, verifique": "Correo electrónico no válido. Por favor, verifica.",
    "register.BUSCAR DADOS": "BUSCAR DATOS",
    "register.Nome da organização": "Nombre de la organización",
    "register.Informe o nome de sua organização": "Ingresa el nombre de tu organización.",
    "register.O campo nome da organização é obrigatório": "El campo del nombre de la organización es obligatorio.",
    "register.Este nome já existe. Por favor, escolha outro": "Este nombre ya existe. Por favor, elige otro.",
    "register.RECUPERAR CONTA": "RECUPERAR CUENTA",
    "register.E-mail não encontrado": "Correo electrónico no encontrado.",
    "register.Digite seu e-mail da plataforma IOK antiga": "Ingresa tu correo electrónico de la antigua plataforma IOK.",
    "register.Não foi possível recuperar sua conta. Verifique seus dados e tente novamente": "No fue posible recuperar tu cuenta. Verifica tus datos e inténtalo nuevamente.",
    "register.Não foi possível recuperar seus dados. Verifique e tente novamente": "No fue posible recuperar tus datos. Verifica e inténtalo nuevamente.",
    "register.PROSSEGUIR": "CONTINUAR",
    "register.VOCÊ ESTÁ SOLICITANDO ACESSO PARA A ORGANIZAÇÃO": "ESTÁS SOLICITANDO ACCESO A LA ORGANIZACIÓN:",
    "register.COM O ADMINISTRADOR": "CON ADMINISTRADOR:",
    "register.E-mail já cadastrado na plataforma. Informe um novo e-mail ou acesse a plataforma com o e-mail já cadastrado": "El correo electrónico ya está registrado en la plataforma. Ingresa un nuevo correo electrónico o accede a la plataforma con el que ya está registrado.",
    "register.Empresa já cadastrada na plataforma. Por favor, informe o nome de uma nova empresa": "La empresa ya está registrada en la plataforma. Por favor, ingresa un nuevo nombre de empresa.",
    "register.VOCÊ NÃO RECONHECEU O USUÁRIO {userName} COMO PARTE DA SUA ORGANIZAÇÃO E POR ISSO A CONTA DELE FOI DELETADA.": "NO RECONOCISTE AL USUARIO {userName} COMO PARTE DE TU ORGANIZACIÓN Y POR ESO SU CUENTA FUE ELIMINADA.",
    "register.NÂO FOI POSSÍVEL DELETAR O USÁRIO {userName}. POR GENTILEZA, TENTE NOVAMENTE MAIS TARDE.": "NO FUE POSIBLE ELIMINAR AL USUARIO {userName}. POR FAVOR, INTÉNTALO NUEVAMENTE MÁS TARDE.",
    "register.CONFIRMAR": "CONFIRMAR",
    "register.Informe o ID da organização": "Ingresa el ID de tu organización.",
    "register.O campo com ID é obrigatório": "El campo ID es obligatorio.",
    "register.Ainda não tenho uma organização. Criar": "Todavía no tengo una organización. Crear",
    "register.ID informado não corresponde a nenhuma companhia. Verifique e tente novamente": "El ID proporcionado no coincide con ninguna empresa. Verifica e inténtalo nuevamente.",
    "register.O ADMINISTRADOR DA ORGANIZAÇÃO RECEBERÁ UM E-MAIL PARA ATIVAR SUA CONTA. POR GENTILIZA, AGUARDE": "EL ADMINISTRADOR DE LA ORGANIZACIÓN RECIBIRÁ UN CORREO ELECTRÓNICO PARA ACTIVAR TU CUENTA DE USUARIO. POR FAVOR, ESPERA.",
    "register.Este nome de franquia já possui uma conta ativa na plataforma": "Esta franquicia ya tiene una cuenta activa en la plataforma.",
    "register.Não foi possível fazer o cadastro. Verifique seus dados e tente novamente": "No fue posible registrarse. Verifica tus datos e inténtalo nuevamente.",
    "register.VOCÊ RECEBERÁ UM E-MAIL PARA CONCLUIR SEU CADASTRO E ATIVAR SUA CONTA DE ADMINISTRADOR": "RECIBIRÁS UN CORREO ELECTRÓNICO PARA FINALIZAR TU REGISTRO Y ACTIVAR TU CUENTA DE ADMINISTRADOR.",
    "register.Nome": "Nombre",
    "register.Informe seu nome": "Ingresa tu nombre.",
    "register.O campo nome é obrigatório": "El campo del nombre es obligatorio",
    "register.E-mail": "Correo electrónico",
    "register.Informe seu e-mail": "Ingresa tu correo electrónico.",
    "register.E-mail inválido. Por favor, verifique novamente": "Correo electrónico no válido. Por favor, verifica",
    "register.Telefone": "Número de teléfono",
    "register.Informe seu telefone": "Ingresa tu número de teléfono",
    "register.Crie sua senha": "Crear una contraseña",
    "register.Informe sua senha": "Ingresa tu contraseña",
    "register.O campo senha deve conter no mínimo 6 caracteres": "El campo de la contraseña debe tener al menos 6 caracteres",
    "register.Confirme sua senha": "Confirmar contraseña",
    "register.As senhas devem ser iguais": "La contraseña debe coincidir",
    "register.CRIAR CONTA": "CREAR CUENTA",
    "register.CONTA ATIVADA COM SUCESSO": "CUENTA ACTIVADA CON ÉXITO",
    "register.ACESSAR": "ACCESO",
    "register.NÃO FOI POSSÍVEL ATIVAR SUA CONTA": "NO FUE POSIBLE ACTIVAR TU CUENTA.",
    "register.Digite seu telefone": "Informa tu número de teléfono.",
    "register.AGUARDE ENQUANTO TRANSFERIMOS SEUS DADOS. ESTE PROCESSO DEVE LEVAR ALGUNS MINUTOS. CASO VOCÊ POSSUA UMA GRANDE QUANTIDADE DE DADOS, A TRANSFERÊNCIA PODE LEVAR ATÉ UMA HORA.": "POR FAVOR ESPERE MIENTRAS TRANSFERIMOS SUS DATOS. ESTE PROCESO DEBE TOMAR UNOS MINUTOS. SI TIENES UNA GRAN CANTIDAD DE DATOS, LA TRANSFERENCIA PUEDE TARDAR HASTA UNA HORA.",
    "register.DADOS TRANSFERIDOS COM SUCESSO! CLIQUE NO BOTÃO ABAIXO PARA ACESSAR A PLATAFORMA.": "¡TRANSFERENCIA DE DATOS EXITOSA! HAZ CLIC EN EL BOTÓN DE ABAJO PARA ACCEDER A LA PLATAFORMA.",
    "register.EMAIL INVÁLIDO. POR GENTILEZA, VERIFIQUE SE SUA CONTA JÁ FOI ATIVADA.": "CORREO ELECTRÓNICO NO VÁLIDO. POR FAVOR, VERIFICA SI TU CUENTA YA HA SIDO ACTIVADA.",
    "register.A nova plataforma IOK agora conta com novas formas de acesso - que são referentes ao tipo de organização em que você atua. O responsável pela sua organização deve migrar a conta principal da empresa, se tornando o administrador, enquanto o restante dos funcionários devem se vincular a ela pelo ID fornecido.": "La nueva plataforma IOK ahora cuenta con nuevas formas de acceso, que están relacionadas con el tipo de organización en la que trabajas. El responsable de tu organización debe migrar la cuenta principal de la empresa, convirtiéndose en administrador, mientras que el resto de los empleados deben vincularse utilizando el ID proporcionado.",
    "register.O administrador da minha organização já realizou a migração da conta e temos um ID. Desejo migrar meus dados de usuário.": "Mi administrador de organización ya ha migrado la cuenta y tenemos un ID. Quiero migrar los datos de mi usuario.",
    "register.Desejo migrar a conta da minha organização e me tornar o administrador.": "Quiero migrar la cuenta de mi organización y convertirme en el administrador.",
    "register.Conta da organização já migrada": "Cuenta de organización ya migrada.",
    "register.Migrar conta da organização": "Migrar cuenta de organización.",
    "register.VOCÊ POSSUI MUITOS MENUS, NÃO CONSEGUIMOS REALIZAR A IMPORTAÇÃO AUTOMÁTICA. SUA CONTA SERÁ ATIVADA, PORÉM OS MENUS PRECISARÃO SER MIGRADOS MANUALMENTE.": "TIENE MUCHOS MENÚS, NO PODEMOS REALIZAR IMPORTACIÓN AUTOMÁTICA. SU CUENTA SE ACTIVARÁ, PERO LOS MENÚS DEBEN MIGRARSE MANUALMENTE.",
    "register.PARA MIGRAR SEUS MENUS, APÓS O LOGIN, CLIQUE NO SEU NOME NO CANTO SUPERIOR DIREITO, CLIQUE EM EDITAR CONTA E DEPOIS EM IMPORTAR MENUS.": "PARA MIGRAR SUS MENÚS, DESPUÉS DE INICIAR SESIÓN, HAGA CLIC EN SU NOMBRE EN LA ESQUINA SUPERIOR DERECHA, HAGA CLIC EN EDITAR CUENTA Y LUEGO EN IMPORTAR MENÚS.",
    "register.Atenção:": "Atención:",
    "register.apenas uma pessoa da organização pode criar a conta e, depois de ativá-la, convidar os demais usuários da empresa para acessá-la.": "solo una persona de la organización puede crear la cuenta y, después de activarla, invitar a los demás usuarios de la empresa a acceder a ella.",
    "register.TOKEN DESENVOLVEDOR CANCELADO": "TOKEN DE DESARROLLADOR CANCELADO",
    "register.Sua senha deve estar entre 8 e 20 caracteres, ter uma letra maiúscula, uma minúscula, um número e um caractere especial": "Su contraseña debe tener entre 8 y 20 caracteres, incluir una letra mayúscula, una minúscula, un número y un carácter especial",
    
    //HOME
    "home.Menus disponíveis na plataforma": "Menús disponibles en la plataforma",
    "home.Criados na plataforma": "Creado en la plataforma",
    "home.Recebidos dos fornos": "Recebidos dos fornos",
    "home.Equipamentos vinculados": "Equipos vinculados",
    "home.Total de receitas cadastradas": "Total de recetas registradas",
    "home.Receitas": "Recetas",
    "home.Receitas em menus": "Recetas en menús",
    "home.Em menus": "En menús",
    "home.Receitas salvas no Cookbook": "Recetas guardadas en el Cookbook",
    "home.No Cookbook": "En el Cookbook",
    "home.Atualizações": "Actualizaciones",
    "home.Copa": "Copa",
    "home.Rocket": "Rocket",
    "home.Single Mag": "Single Mag",
    "home.Versão instalada": "Versión instalada",
    "home.Versão disponível": "Versión disponible",
    "home.Usuários cadastrados": "Usuarios registrados",
    "home.Aceitação pendente": "Aceptación pendiente",
    "home.Atualizado": "Actualizado",
    "home.OLÁ": "HOLA",
    "home.É muito bom ter você aqui!": "¡Es genial tenerte aquí!",
    "home.Com a Plataforma IOK é possível administrar seus fornos de onde estiver, criar e gerenciar receitas e menus, fazer backups, analisar os dados de seus equipamentos e muito mais!": "¡Con la Plataforma IOK podrás gestionar tus hornos desde donde estés, crear y gestionar recetas y menús, realizar copias de seguridad, analizar datos de tu equipo y mucho más!",
    "home.Conheça a plataforma": "Descubre la plataforma",
    "home.Taxa de erro por modelo": "Tasa de error por modelo",
    "home.Erro": "Error",
    "home.Modelos em evidência": "Modelos destacados",
    "home.Modelos": "Modelos",
    "home.Total de equipamentos vinculados": "Total de equipos vinculados",
    "home.Total de equipamentos online": "Total de equipos en línea",
    "home.Equipamentos online": "Equipos en línea",
    "home.Países com Prática": "Países con Prática",
    "home.Países": "Países",
    "home.Aguarde enquanto carregamos os dados": "Espere mientras cargamos los datos",
    "home.Quase lá! Aguarde um pouco mais": "¡Casi listo! Espere un poco más",
    "home.QUEREMOS SABER SUA OPINIÃO SOBRE": "QUEREMOS SABER TU OPINIÓN SOBRE",
    "home.Valorizamos muito seu ponto de vista e, por isso, este formulário de pesquisa de satisfação sobre a Plataforma {model} foi criado!": "¡Valoramos mucho tu punto de vista y, por eso, se creó este formulario de encuesta de satisfacción en la Plataforma {model}!",
    "home.Valorizamos muito seu ponto de vista e, por isso, este formulário de pesquisa de satisfação sobre a linha {model} foi criado!": "¡Valoramos mucho tu punto de vista y por eso creamos este formulario de encuesta de satisfacción sobre la línea {model}!",
    "home.Suas respostas nos ajudarão a aprimorar nossos serviços, garantindo que continuemos a oferecer a você a melhor experiência possível.": "Sus respuestas nos ayudarán a mejorar nuestros servicios, asegurando que sigamos brindándole la mejor experiencia posible",
    "home.Reserve uns minutinhos de seu dia e participe!": "¡Tómate unos minutos de tu día y participa!",
    "home.Responder a pesquisa": "Responde la encuesta",
    "home.Vendas por Equipamento": "Ventas por Equipo",
    "home.Total de equipamentos vendidos": "Total de Equipos Vendidos",
    "home.Equipamentos vendidos": "Equipos Vendidos",
    "home.Clique para atualizar o software": "Haz clic para actualizar el software",
    "home.Aceitação de software pendente": "Aceptación de software pendiente",
    "home.Software atualizado": "Software actualizado",
    "home.NENHUM EQUIPAMENTO VINCULADO": "NINGÚN EQUIPO VINCULADO",
    "home.FORNOS LIGADOS": "HORNOS ENCENDIDOS",
    "home.Enviando dados": "Enviando datos",
    "home.Sem envio de dados": "Sin envío de datos",
    "home.Criados na Plataforma": "Creados en la Plataforma",
    "home.Apenas no Cookbook": "Solo en el Cookbook",
    "home.Usuários na companhia": "Usuarios en la empresa",
    "home.Inativos": "Inactivos",
    "home.Online": "En línea",
    "home.Atualizações de equipamentos": "Actualizaciones de equipos",
    "home.Modelos de equipamentos": "Modelos de equipos",
    "home.Atualizados": "Actualizados",
    "home.Aguardando Aceite": "Pendientes de aceptación",
    "home.Desatualizados": "Desactualizados",
    "home.Versão": "Versión",
    "home.Recente": "Reciente",
    "home.Legenda": "Leyenda",
    "home.Chat": "Chat",
    
    //MAIN
    "main.HOME": "INICIO",
    "main.COOKBOOK": "COOKBOOK",
    "main.MEUS MENUS": "MIS MENÚS",
    "main.EQUIPAMENTOS": "EQUIPAMIENTO",
    "main.USUÁRIOS": "USUARIOS",
    "main.ATENDIMENTOS": "SERVICIOS",
    "main.Idioma": "Idioma",
    "main.Editar conta": "Editar cuenta",
    "main.Configurações": "Configuraciones",
    "main.Sair": "Cerrar sesión",
    "main.Configurações salvas com sucesso!": "!Configuraciones guardadas exitosamente!",
    "main.SALVAR": "GUARDAR",
    "main.CONFIGURAÇÕES": "CONFIGURACIONES",
    "main.Tema dark": "Tema oscuro",
    "main.Notificações": "Notificaciones",
    "main.Informações para as receitas": "Información de recetas",
    "main.Peso:": "Peso",
    "main.Gramas": "Gramos",
    "main.Oz": "Onzas",
    "main.Temperatura:": "Temperaturas:",
    "main.Celsius (°C)": "Celsius (°C)",
    "main.Fahrenheit (°F)": "Fahrenheit (°F)",
    "main.Conta editada com sucesso!": "Cuenta editada exitosamente!",
    "main.EDITAR CONTA": "EDITAR CUENTA",
    "main.Nome": "Nombre",
    "main.Preencha com o seu nome": "Ingresa tu nombre",
    "main.Telefone": "Teléfono",
    "main.Preencha com o seu telefone": "Ingresa tu número de teléfono",
    "main.E-mail": "Correo electrónico",
    "main.Preencha com o seu e-mail": "Ingresa tu correo electrónico",
    "main.Alterar Senha": "Cambiar contraseña",
    "main.ALTERAR SENHA": "CAMBIAR CONTRASEÑA",
    "main.Senha atual": "Contraseña actual",
    "main.Nova senha": "Nueva contraseña",
    "main.Confirmar nova senha": "Confirmar nueva contraseña",
    "main.Informe sua senha atual": "Ingresa tu contraseña actual",
    "main.O campo senha deve conter no mínimo 6 caracteres": "El campo de la contraseña debe tener al menos 6 caracteres",
    "main.Informe sua nova senha": "Ingresa tu nueva contraseña",
    "main.Confirme sua nova senha": "Confirma tu nueva contraseña",
    "main.Sua nova senha deve conter no mínimo 6 caracteres": "Tu nueva contraseña debe tener al menos 6 caracteres",
    "main.INFORME SUA SENHA": "INGRESA TU CONTRASEÑA",
    "main.Informe sua senha para realizar a alteração de e-mail da plataforma:": "Ingresa tu contraseña para cambiar tu correo electrónico en la plataforma:",
    "main.CONFIRMAR": "CONFIRMAR",
    "main.Existem campos que não foram preenchidos corretamente": "Hay campos que no se han llenado correctamente",
    "main.Informe sua senha para prosseguir com a alteração de e-mail": "Ingresa tu contraseña para proceder con el cambio de correo electrónico",
    "main.Senha alterada com sucesso": "Contraseña cambiada exitosamente",
    "main.Informe sua senha atual corretamente": "Ingresa tu contraseña actual correctamente",
    "main.As senhas devem ser iguais": "Las contraseñas deben coincidir",
    "main.Nome do novo tipo de usuário": "Nombre del nuevo tipo de usuario",
    "main.Dê um nome para o novo tipo de usuário": "Asigna un nombre al nuevo tipo de usuario",
    "main.Token Desenvolvedor": "Token de Desarrollador",
    "main.O Token Desenvolvedor é um código único e intransferível que permite a realização de alterações": "El Token de Desarrollador es un código único e intransferible que permite la realización de cambios a nivel de desarrollo directamente en el código de la plataforma mediante APIs externas. Estas posibilitan la personalización de la plataforma para satisfacer mejor las necesidades de su empresa.",
    "main.É recomendado que estas alterações sejam realizadas por um profissional da área de tecnologia": "Se recomienda que estos cambios sean realizados por un profesional del área de tecnología.",
    "main.Para acessar o token, informe sua senha": "Para acceder al token, ingrese su contraseña.",
    "main.Copie e cole o token na autenticação de todas as requisições.": "Copie y pegue el token en la autenticación de todas las solicitudes.",
    "main.Seu Token": "Su token",
    "main.Token copiado com sucesso!": "¡Token copiado correctamente!",
    "main.Você deseja cancelar o preenchimento das informações?": "¿Desea cancelar el llenado de la información?",
    "main.Rever tutoriais": "Revisar tutoriales",
    "main.Tutoriais resetados com sucesso!": "Tutoriales restablecidos con éxito!",
    "main.review.tutorials": "¿Desea revisar los tutoriales de la plataforma IOK?",
    "main.Procurar": "Buscar",
    "main.review.manual": "También es posible guardarlo en su computadora.",
    "main.review.download": "Acceder al manual",
    
    //MENUS
    "menus.Procurar menu": "Menú de búsqueda o usuario",
    "menus.Procurar menu excluído": "Buscar menú eliminado",
    "menus.Menus": "Menús",
    "menus.Lixeira": "Papelera",
    "menus.CRIAR MENU": "CREAR MENÚ",
    "menus.IMPORTAR MENU": "IMPORTAR MENÚ",
    "menus.Os arquivos serão mantidos na lixeira por 30 dias a contar de sua data de exclusão. Após este período, eles serão excluídos definitivamente.": "Los archivos se mantendrán en la papelera durante 30 días desde la fecha de eliminación. Después de este período, serán eliminados definitivamente.",
    "menus.VOLTAR": "REGRESO",
    "menus.Compatível com: ": "Compatible con: ",
    "menus.Última atualização: ": "Última actualización: ",
    "menus.Última atualização": "Última actualización",
    "menus.EXPORTAR MENU": "EXPORTAR MENÚ",
    "menus.EDITAR MENU": "EDITAR MENÚ",
    "menus.Equipamentos associados": "Equipo asociado",
    "menus.Grupos": "Grupos",
    "menus.Procurar grupo": "Buscar grupo",
    "menus.CRIAR GRUPO": "CREAR GRUPO",
    "menus.receitas": "Recetas",
    "menus.Nenhum grupo cadastrado": "Ningún grupo registrado",
    "menus.Nenhum menu cadastrado": "Ningún menú registrado",
    "menus.Nome": "Nombre",
    "menus.Modelo": "Modelo",
    "menus.Atividade": "Actividad",
    "menus.Associação": "Asociación",
    "menus.Exportar": "Exportar",
    "menus.Editar": "Editar",
    "menus.Excluir": "Eliminar",
    "menus.Equips": "Equipar",
    "menus.Receitas": "Recetas",
    "menus.Compatibilidade": "Compatibilidad",
    "menus.Versão": "Versión",
    "menus.Origem": "Origen",
    "menus.Excluído por": "Eliminado por",
    "menus.Data de exclusão": "Fecha de eliminación",
    "menus.Restaurar": "Restaurar",
    "menus.Existem campos que não foram preenchidos": "Hay campos que no han sido llenados.",
    "menus.Menu criado com sucesso!": "Menú creado exitosamente!",
    "menus.Existem campos com informações inválidas": "Hay campos con información inválida",
    "menus.SALVAR": "GUARDAR",
    "menus.CANCELAR": "CANCELAR",
    "menus.Nome do menu": "Nombre del menú",
    "menus.Informe o nome do menu": "Informar nombre del menú",
    "menus.Preencha o nome do menu sem caracteres especiais": "Llenar el nombre del menú sin caracteres especiales",
    "menus.Selecionar": "Seleccionar",
    "menus.Idioma": "Idioma",
    "menus.Temperatura de pré-aquec 1": "Temperatura de precalentamiento 1",
    "menus.Informe a temperatura de pré-aquec 1": "Informar temperatura de precalentamiento 1",
    "menus.Temperatura de pré-aquec 2": "Temperatura de precalentamiento 2",
    "menus.Informe a temperatura de pré-aquec 2": "Informar temperatura de precalentamiento 2",
    "menus.Tempo para estabilização": "Tiempo de estabilización",
    "menus.Informe o tempo para estabilização": "Informar tiempo de estabilización",
    "menus.Desativar pré-aquec 2": "Desactivar precalentamiento 2",
    "menus.Configurações de data e hora": "Configuraciones de fecha y hora",
    "menus.Data:": "Fecha:",
    "menus.DD/MM/AAAA": "DD/MM/AAAA",
    "menus.Hora:": "Hora:",
    "menus.24h": "24h",
    "menus.AM/PM": "AM/PM",
    "menus.EUR: DD/MM/AAAA": "EUR: DD/MM/AAAA",
    "menus.USA: MM/DD/AAAA": "USA: MM/DD/AAAA",
    "menus.ISO: AAAA/MM/DD": "ISO: AAAA/MM/DD",
    "menus.Seleção de acessos para habilitar": "Selección de acceso para habilitar",
    "menus.Modo manual": "Modo manual",
    "menus.Habilitado": "Habilitado",
    "menus.Desabilitado": "Deshabilitado",
    "menus.Favoritos": "Favoritos",
    "menus.Aquecer/Dourar": "Calor/Dorado",
    "menus.Repetir receita": "Repetir receta",
    "menus.Configurações gerais do menu": "Configuraciones generales del menú",
    "menus.Temperatura": "Temperatura",
    "menus.Temperatura:": "Temperatura:",
    "menus.Celsius (°C)": "Celsius (°C)",
    "menus.Fahrenheit (°F)": "Fahrenheit (°F)",
    "menus.Peso": "Peso",
    "menus.Gramas": "Gramos",
    "menus.Oz": "Onza",
    "menus.Tema:": "Tema:",
    "menus.Dark": "Oscuro",
    "menus.Light": "Claro",
    "menus.Introdução:": "Introducción:",
    "menus.Ativada": "Activado",
    "menus.Desativada": "Desactivado",
    "menus.Menu deletado com sucesso!": "Menú eliminado exitosamente!",
    "menus.Não foi possivel deletar o menu": "No se puede eliminar el menú",
    "menus.Sim": "Sí",
    "menus.Não": "No",
    "menus.Excluir definitivamente": "Eliminar permanentemente",
    "menus.SALVAR NO DISPOSITIVO": "GUARDAR EN EL DISPOSITIVO",
    "menus.EXPORTAR": "EXPORTAR",
    "menus.Selecione os modelos e versões dos equipamentos que receberão o menu.": "Seleccione los modelos y versiones de equipos para recibir el menú",
    "menus.Forno": "Horno",
    "menus.Fundo verde": "Fondo verde",
    "menus.Fundo preto": "Fondo negro",
    "menus.Linux": "Linux",
    "menus.Atenção: antes de transferir o menu de seu pen drive para o equipamento, é necessário descompactar o arquivo, exceto para menus de equipamentos Linux.": "Atención: antes de transferir el menú desde su memoria USB al equipo, es necesario descomprimir el archivo, excepto para los menús de equipos Linux.",
    "menus.Selecione os equipamentos para os quais deseja exportar o menu.": "Seleccione el equipo para el cual desea exportar el menú.",
    "menus.Nome do equipamento": "Nombre del equipo",
    "menus.Selecionar todos": "Seleccionar todo",
    "menus.Selecionar todas": "Seleccionar todo",
    "menus.Categoria: ": "Categoría: ",
    "menus.Você deseja excluir o menu?": "¿Desea eliminar el menú?",
    "menus.O menu será deletado da plataforma, mas permanecerá no equipamento. Uma cópia de segurança será criada automaticamente e ficará disponível por 30 dias em Meus Menus - Lixeira.": "El menú se eliminará de la plataforma, pero se mantendrá en el equipo. Se creará automáticamente una copia de seguridad que estará disponible durante 30 días en Mis Menús - Papelera.",
    "menus.Você deseja excluir o arquivo definitivamente?": "¿Desea eliminar el archivo permanentemente?",
    "menus.Esta ação não poderá ser desfeita.": "Esta acción no se puede deshacer.",
    "menus.Menu editado com sucesso!": "Menú editado exitosamente!",
    "menus.IMPORTAR": "IMPORTAR",
    "menus.VERIFICAÇÃO DE VERSÃO": "VERIFICACIÓN DE VERSIÓN",
    "menus.Para conferir a versão da placa de seu equipamento, siga os seguintes passos:": "Para verificar la versión de la placa del equipo, siga los siguientes pasos:",
    "menus.No forno, acesse Configurações;": "En el horno, acceda a Configuraciones;",
    "menus.Insira a senha 456789;": "Ingrese la contraseña 456789;",
    "menus.Selecione a opção Sistema;": "Seleccione la opción Sistema;",
    "menus.Selecione Informações do Fabricante;": "Seleccione Información del fabricante;",
    "menus.O modelo de sua placa estará na linha Firmware IHM;": "El modelo de su placa estará en la línea Firmware IHM;",
    "menus.1ª geração A": "1ra generación A",
    "menus.Firmware IHM: 12.3.4": "Firmware IHM: 12.3.4",
    "menus.1ª geração B": "1ra generación B",
    "menus.2ª geração/Linux:": "2da generación/Linux",
    "menus.Firmware IHM: L1.2.3": "Firmware IHM: L1.2.3",
    "menus.Selecione o modelo/versão do equipamento do qual deseja importar o menu. Saiba como conferir a versão de seu equipamento": "Seleccione el modelo/versión del equipo desde el cual desea importar el menú. Sepa cómo verificar la versión de su equipo ",
    "menus.Selecione o modelo/versão do equipamento": "Seleccione el modelo/versión del equipo",
    "menus.Como verificar a versão da placa": "Cómo verificar la versión de la placa",
    "menus.1° Geração": "1ra generación",
    "menus.Menu restaurado com sucesso!": "Menú restaurado exitosamente!",
    "menus.Não foi possivel restaurar o menu": "No se puede restaurar el menú",
    "menus.RESTAURAR ARQUIVO": "RESTAURAR ARCHIVO",
    "menus.Você deseja restaurar o arquivo?": "¿Desea restaurar el archivo?",
    "menus.O arquivo será restaurado como uma nova versão na plataforma, na guia Todos. Para salvá-lo no equipamento, exporte-o.": "El archivo se restaurará como una nueva versión en la plataforma en la pestaña Todo. Para guardarlo en su dispositivo, expórtelo.",
    "menus.EXCLUIR MENU": "ELIMINAR MENÚ",
    "menus.Nenhum equipamento associado": "Ningún equipo asociado",
    "menus.Nomeie o novo menu": "Nombrar el nuevo menú",
    "menus.Nomeie o novo grupo": "Nombrar el nuevo grupo",
    "menus.Nome do grupo": "Nombre del grupo",
    "menus.Preencha o nome do grupo sem caracteres especiais": "Llene el nombre del grupo sin caracteres especiales",
    "menus.Pré-aquecimento": "Precalentamiento",
    "menus.Pré-aquecimento:": "Precalentamiento:",
    "menus.Grupo criado com sucesso!": "Grupo creado exitosamente!",
    "menus.SELECIONE UMA IMAGEM": "SELECCIONAR UNA IMAGEN",
    "menus.SELECIONAR": "SELECCIONAR",
    "menus.Selecionar do dispositivo": "Seleccionar desde el dispositivo",
    "menus.Selecionar do banco de imagens": "Seleccionar desde el banco de imágenes",
    "menus.Formato .JPG ou .PNG": "Formato .JPG o .PNG",
    "menus.Procurar imagem": "Buscar imagen",
    "menus.Pertence ao menu": "Pertenece al menú",
    "menus.Alterar imagem": "Cambiar imagen",
    "menus.Remover imagem": "Quitar imagen",
    "menus.EDITAR GRUPO": "EDITAR GRUPO",
    "menus.CRIAR RECEITA": "CREAR RECETA",
    "menus.SALVAR DO COOKBOOK": "GUARDAR DESDE EL LIBRO DE COCINA",
    "menus.Procurar receita do grupo": "Buscar receta del grupo",
    "menus.Ingrediente principal": "Ingrediente principal",
    "menus.Limpar filtros": "Limpiar filtros",
    "menus.Filtrar": "Filtrar",
    "menus.Mover receitas": "Mover recetas",
    "menus.Excluir receitas": "Eliminar recetas",
    "menus.Editar grupo": "Editar grupo",
    "menus.Excluir grupo": "Eliminar grupo",
    "menus.aqui": "aquí",
    "menus.Se o código possuir apenas números e o fundo da tela for verde, pertence à 1ª A, se possuir apenas números e o fundo da tela for preta, pertence à 1ª B e, se começar com as letras L, F ou S, sua placa pertence à 2ª geração/Linux.": "Si el código tiene solo números y el fondo es verde, pertenece a 1ra A; si tiene solo números y el fondo es negro, pertenece a 1ra B y, si comienza con las letras L, F o S, su placa pertenece a 2da generación/Linux.",
    "menus.1ª A - Fundo verde": "1ra A - Fondo verde",
    "menus.1ª B - Fundo preto": "1ra B - Fondo negro",
    "menus.2ª - Linux": "2da - Linux",
    "menus.Tivemos um problema. Tente novamente mais tarde.": "Hemos tenido un problema. Intente nuevamente más tarde.",
    "menus.Grupo editado com sucesso!": "Grupo editado exitosamente!",
    "menus.AINDA NÃO HÁ GRUPOS AQUI :(": "AÚN NO HAY GRUPOS AQUÍ :(",
    "menus.description.AINDA NÃO HÁ GRUPOS AQUI :(": "Haz clic en el botón ubicado en la esquina superior derecha y agrega grupos.",
    "menus.NENHUM MENU NA LIXEIRA": "NO HAY MENÚ EN LA BASURA",
    "menus.AINDA NÃO HÁ MENUS AQUI :(": "AÚN NO HAY MENÚS AQUÍ :(",
    "menus.description.AINDA NÃO HÁ MENUS AQUI :(": "Haga clic en uno de los botones ubicados en la esquina superior derecha y agregue menús.",
    "menus.Adicionar imagem": "Agregar imagen",
    "menus.Nome da receita": "Nombre de la receta",
    "menus.Origem da receita": "Origen de la receta",
    "menus.Detalhes da receita": "Detalles de la receta",
    "menus.Programação da receita": "Programación de la receta",
    "menus.Nomeie sua receita": "Nombre su receta",
    "menus.Preencha o nome da receita sem caracteres especiais": "Complete el nombre de la receta sin caracteres especiales",
    "menus.Apenas os caracteres @#%&*-+()!\"<>:;\\/?. são permitidos": "Solo se permiten los caracteres @#%&*-+()!\"<>:;\/?.",
    "menus.Tipo de prato": "Tipo de comida",
    "menus.SALVAR RECEITAS DO COOKBOOK": "GUARDAR RECETAS DESDE EL LIBRO DE COCINA",
    "menus.Selecione as receitas que deseja salvar no grupo de seu menu:": "Seleccione las recetas que desea guardar en su grupo de menú:",
    "menus.Procurar receita": "Buscar receta",
    "menus.deleteGroupSuccess":
    "{count, plural, one {¡Grupo eliminado con éxito!} other {¡Grupos eliminados con éxito!}}",
    "menus.deleteGroupError":
    "{count, plural, one {No se pudo eliminar el grupo} other {No se pudieron eliminar los grupos}}",
    "menus.EXCLUIR GRUPO": "ELIMINAR GRUPO",
    "menus.confirmDeleteGroupMessage":
    "{count, plural, one {¿Desea eliminar el grupo de forma permanente?} other {¿Desea eliminar los grupos de forma permanente?}}",
    "menus.AINDA NÃO HÁ RECEITAS AQUI :(": "AÚN NO HAY RECETAS AQUÍ :(",
    "menus.description.AINDA NÃO HÁ RECEITAS AQUI :(": "Haga clic en uno de los botones ubicados en la esquina superior derecha y agregue recetas.",
    "menus.Temp. de entrada": "Temperatura inicial",
    "menus.Temp. de pré-aquec": "Temperatura de precalentamiento",
    "menus.Ingredientes para montagem": "Ingredientes para el montaje",
    "menus.Instruções operacionais": "Instrucciones de operación",
    "menus.Passo": "Paso",
    "menus.Temp": "Temp ",
    "menus.Temp.": "Temp. ",
    "menus.Tempo": "Tiempo ",
    "menus.Velocidade do ar": "Velocidad del aire",
    "menus.Micro-ondas": "Microondas",
    "menus.Resistência inferior": "Resistencia inferior",
    "menus.Informações": "Información",
    "menus.Digite as informações do passo": "Escriba la información del paso",
    "menus.desativar": "desactivar ",
    "menus.Ingredientes": "Ingredientes",
    "menus.Temperatura de entrada": "Temperatura inicial",
    "menus.Equipamentos compatíveis": "Equipo compatible",
    "menus.Tempo total": "Tiempo total",
    "menus.SALVAR NO COOKBOOK": "GUARDAR EN EL COOKBOOK",
    "menus.ver localização": "ver ubicación",
    "menus.SELECIONE RECEITAS PARA EXCLUIR": "SELECCIONAR RECETAS PARA ELIMINAR",
    "menus.Você deseja excluir as receitas selecionadas definitivamente": "¿Desea eliminar definitivamente las recetas seleccionadas?",
    "menus.Receitas deletadas com sucesso!": "Recetas eliminadas exitosamente!",
    "menus.Informe aqui os ingredientes para montagem": "Informe aquí los ingredientes para el montaje",
    "menus.Informe aqui as instruções operacionais": "Informe aquí las instrucciones de operación",
    "menus.Adicionar passo": "Agregar paso",
    "menus.Receita criada com sucesso!": "Receta creada exitosamente!",
    "menus.Ideal para:": "Ideal para: ",
    "menus.editar detalhes": "editar detalles",
    "menus.excluir": "eliminar",
    "menus.editar": "editar",
    "menus.Receita editada com sucesso!": "Receta editada exitosamente!",
    "menus.Passo deletado com sucesso!": "Paso eliminado exitosamente!",
    "menus.Não foi possivel deletar o passo": "No se puede eliminar el paso",
    "menus.EXCLUIR PASSO": "ELIMINAR PASO",
    "menus.Você deseja excluir este passo": "¿Desea eliminar este paso?",
    "menus.Esta ação não poderá ser desfeita. Caso prefira, é possível apenas desativá-lo, mantendo assim sua configuração.": "Esta acción no se puede deshacer. Si lo prefiere, es posible desactivarlo manteniendo su configuración.",
    "menus.Plataforma": "Plataforma",
    "menus.Receita salva com sucesso!": "Receta guardada exitosamente!",
    "menus.Exportar receitas": "Exportar recetas",
    "menus.expandir": "expandir",
    "menus.Vapor combinado": "Vapor combinado",
    "menus.Ar quente": "Aire caliente",
    "menus.Sonda": "Sonda",
    "menus.Tempo (min)": "Tiempo (min)",
    "menus.Umidade (%)": "Humedad (%)",
    "menus.Injeção de vapor": "Inyección de vapor",
    "menus.Dumper aberto": "Basculante abierto",
    "menus.Informe o peso": "Informe el peso",
    "menus.Informe a temperatura de entrada": "Informe la temperatura inicial",
    "menus.Informe os ingredientes para montagem": "Ingrese los ingredientes para el montaje",
    "menus.Informe as instruções operacionais": "Ingrese las instrucciones de operación",
    "menus.Injeção de vapor (seg)": "Inyección de vapor (seg)",
    "menus.Aquecer mais": "Calentar más",
    "menus.Dourar mais": "Dorar más",
    "menus.Aquecer e dourar mais": "Calentar y dorar más",
    "menus.Favoritar receita": "Receta favorita",
    "menus.Apenas favoritos": "Solo favoritos",
    "menus.Forno combinado": "Horno combinado",
    "menus.Cocção múltipla": "Cocción múltiple",
    "menus.Receitas Technicook": "Recetas Technicook",
    "menus.Editar grupos": "Editar grupos",
    "menus.Informe a data": "Ingresar fecha",
    "menus.Informe a hora": "Ingresar hora",
    "menus.até 300": "hasta 300",
    "menus.Vapor": "Vapor ",
    "menus.Turbina": "Turbina",
    "menus.Criar grupo": "Crear grupo",
    "menus.MOVER": "MOVER ",
    "menus.Configurações de acessos": "Acceder a configuraciones:",
    "menus.SELECIONE RECEITAS PARA MOVER": "SELECCIONAR RECETAS PARA MOVER",
    "menus.AVANÇAR": "AVANZAR",
    "menus.Selecione ou crie um grupo no mesmo menu para mover as receitas selecionadas ou as mova para outro menu. Note que apenas os menus/grupos compatíveis com as predefinições das receitas serão exibidos.": "Seleccione o cree un grupo en el mismo menú para mover recetas seleccionadas o muévalas a otro menú. Tenga en cuenta que solo se mostrarán los menús/grupos que sean compatibles con las configuraciones preestablecidas de la receta.",
    "menus.Mover receitas para o mesmo menu": "Mover recetas al mismo menú",
    "menus.Mover receitas para outro menu": "Mover recetas a otro menú",
    "menus.Selecionar grupo": "Seleccionar grupo",
    "menus.Nenhuma receita foi selecionada": "No se seleccionó ninguna receta",
    "menus.Passo editado com sucesso!": "Paso editado exitosamente!",
    "menus.Menu atualizado": "Menú actualizado",
    "menus.até 260": "hasta 260",
    "menus.Umidade na câmara": "Humedad de la cámara",
    "menus.Passos": "Pasos",
    "menus.ativar": "activar",
    "menus.Informe a temperatura de pré-aquec": "Ingrese la temperatura de precalentamiento",
    "menus.Movas as receitas selecionadas para outro menu. Note que apenas os menus compatíveis com as predefinições das receitas serão exibidos.": "Mover recetas seleccionadas a otro menú. Tenga en cuenta que solo se mostrarán los menús que sean compatibles con las configuraciones preestablecidas de la receta.",
    "menus.Sonda (°C)": "Sonda (ºC)",
    "menus.Turbo Grill": "Grill Turbo",
    "menus.Pré-aquecimento padrão, conforme passo 1": "Precalentamiento estándar, según el paso 1",
    "menus.salvar": "guardar",
    "menus.até": "hasta",
    "menus.Verificação de receita": "Verificación de la receta",
    "menus.Auto import": "Importación automática",
    "menus.Atualização forçada": "Actualización forzada",
    "menus.Lista de receitas exportada com sucesso!": "Lista de recetas exportada exitosamente!",
    "menus.Receita movida com sucesso!": "Receta movida exitosamente!",
    "menus.Receitas movidas com sucesso!": "Recetas movidas exitosamente!",
    "menus.+ Receita": "Receta",
    "menus.Escolha um idioma compatível com o equipamento": "Seleccione un idioma compatible con el equipo",
    "menus.MENU IMPORTADO COM SUCESSO!": "Menú importado correctamente!",
    "menus.Dourar": "Marrón",
    "menus.Não atribuir a menu": "No asignar al menú",
    "menus.Todos": "Todos",
    "menus.Meus menus": "Mis menús",
    "menus.Para salvar uma receita, preencha todos os campos": "Para guardar una receta, complete todos los campos",
    "menus.Selecione os grupos de equipamentos para os quais deseja exportar o menu.": "Seleccione los grupos de equipos para los que desea exportar el menú.",
    "menus.Você deseja excluir este passo?": "¿Desea eliminar este paso?",
    "menus.Formato inválido. São permitidos apenas os formatos .jpeg e .png": "Formato no válido. Solo se permiten los formatos .jpeg y .png.",
    "menus.Reordenar grupos": "Reordenar grupos",
    "menus.O que deseja fazer?": "¿Qué deseas hacer?",
    "menus.Reordenar receitas": "Reordenar recetas",
    "menus.ITENS REORDENADOS COM SUCESSO! PARA APLICAR AS ALTERAÇÕES NO FORNO, EXPORTE O MENU.": "¡ELEMENTOS REORDENADOS CON ÉXITO! PARA APLICAR LOS CAMBIOS EN EL HORNO, EXPORTA EL MENÚ.",
    "menus.ARRASTE OS ITENS PARA O LOCAL DESEJADO": "Arrastra los elementos a la ubicación deseada.",
    "menus.Dumper": "Compuerta",
    "menus.Aberto": "Abierto",
    "menus.Fechado": "Cerrado",
    "menus.Intermitente": "Intermitente",
    "menus.Se o seu menu incluir itens sensíveis à uniformidade, recomendamos definir o Tempo de Estabilização entre 3:00 e 5:00 minutos. Caso contrário, você pode deixá-lo em 5 segundos.": "Si su menú incluye elementos sensibles a la uniformidad, le recomendamos configurar el Tiempo de Estabilización entre 3:00 y 5:00 minutos. De lo contrario, puede dejarlo en 5 segundos.",
    "menus.Selecione o menu que deseja exportar:": "Seleccione el menú que desea exportar:",
    "menus.Temperatura de pré-aquecimento": "Temperatura de precalentamiento",
    "menus.Temperatura de lastro": "Temperatura de lastre",
    "menus.Temperatura de teto": "Temperatura del techo",
    "menus.Volume de injeção de vapor (ml)": "Volumen de inyección de vapor (ml)",
    "menus.Parada de turbina": "Parada de turbina",
    "menus.Alta": "Alta",
    "menus.Média": "Media",
    "menus.Baixa": "Baja",
    "menus.a": "el",
    "menus.Valor da injeção": "Valor de inyección",
    "menus.Volume: até 999ml": "Volumen: hasta 999ml",
    "menus.Tempo: até 15 segundos": "Tiempo: hasta 15 segundos",
    "menus.Tempo de injeção de vapor (seg)": "Tiempo de inyección de vapor (seg)",
    "menus.Atenção!": "¡Atención!",
    "menus.Verifique as receitas do menu e ajuste os valores da Injeção de Vapor após alterar sua unidade de medida.": "Consulte las recetas del menú y ajuste los valores de inyección de vapor después de cambiar su unidad de medida.",
    "menus.Certifique-se de que a unidade de temperatura (°C ou °F) definida no equipamento seja a mesma que foi selecionada na criação do menu:": "Asegúrese de que la unidad de temperatura (°C o °F) definida en el equipo sea la misma que la seleccionada al crear el menú:",
    "menus.Injeção desativada": "Inyección deshabilitada",
    "menus.Selecione a unidade de temperatura que está definida no equipamento:": "Seleccione la unidad de temperatura que está definida en el equipo:",
    "menus.Clique para atualizar": "Haga clic para actualizar",
    "menus.A função Atualização Forçada envia automaticamente o menu para os equipamentos selecionados, e que possuam versão compatível com este tipo de atualização, na próxima vez em que forem ligados. Os fornos que não estiverem atualizados ainda precisarão realizar o aceite manual.": "La función Actualización Forzada envía automáticamente el menú al equipo seleccionado, que tenga una versión compatible con este tipo de actualización, la próxima vez que se encienda. Los hornos que no estén actualizados deberán someterse a una aceptación manual.",
    "menus.As opções selecionadas estarão disponíveis nos equipamentos que receberem este menu, podendo ser utilizadas pelo operador. É possível alterar estas configurações posteriormente no próprio forno ou pela plataforma.": "Las opciones seleccionadas estarán disponibles en el equipo que reciba este menú y podrán ser utilizadas por el operador. Es posible cambiar estos ajustes más tarde en el propio horno o a través de la plataforma.",
    "menus.+ Menu": "+ Menú",
    "menus.Não foi possivel deletar as receitas": "No se pueden eliminar recetas",
    "menus.PRÉ": "PRE",
    "menus.Speed Ovens": "Speed Ovens",
    "menus.Fornos Combinados": "Hornos Combinados",
    "menus.Fornos de Panificação": "Hornos de Panadería",
    "menus.Após a criação, o tipo do menu não pode ser alterado. Ele só pode ser definido no momento da criação.": "Después de la creación, el tipo de menú no se puede cambiar. Solo se puede definir en el momento de la creación.",
    "menus.Pré-aquecimento do grupo": "Precalentamiento del grupo",
    "menus.Atenção: antes de transferir o menu de seu pen drive para o equipamento, é necessário descompactar o arquivo, transferindo a pasta PRATICA para o equipamento.": "Atención: antes de transferir el menú de su pendrive al equipo, debe descomprimir el archivo, transfiriendo la carpeta PRATICA al equipo.",
    "menus.Tamanho máximo": "Tamaño máximo",
    "menus.Possibilita que o operador do forno crie parâmetros e os execute em seguida.": "Permite que el operador del horno cree parámetros y los ejecute a continuación.",
    "menus.Acesso também à execução das receitas favoritas.": "También permite el acceso a la ejecución de recetas favoritas.",
    "menus.Possibilita que o operador adicione mais tempo para aquecer/dourar a refeição depois de sua execução.": "Permite al operador añadir más tiempo para calentar/dorar la comida después de su ejecución.",
    "menus.Possibilita a repetição da receita assim que sua execução é finalizada.": "Permite la repetición de la receta tan pronto como se complete su ejecución.",
    "menus.Acesso exclusivo às receitas favoritas.": "Acceso exclusivo a las recetas favoritas.",
    "menus.Habilita o lembrete para o operador conferir se o alimento já está dentro do forno.": "Habilita el recordatorio para que el operador verifique si la comida ya está dentro del horno.",
    "menus.O forno importa automaticamente, ao ligar, um menu que esteja salvo em pen drive e nele inserido.": "El horno importa automáticamente, al encenderse, un menú guardado en un pen drive.",
    "menus.Possibilita a cocção de diversos alimentos simultaneamente, um em cada GN.": "Permite la cocción simultánea de diversos alimentos, uno en cada GN.",
    "menus.Permite a execução de receitas pré programadas, vindas de fábrica.": "Permite la ejecución de recetas preprogramadas de fábrica.",
    "menus.Permite acesso à função turbo grill, que atinge até 300°C.": "Permite acceso a la función turbo grill, que alcanza hasta 300°C.",
    "menus.Possibilita que o operador adicione mais tempo para dourar a refeição depois de sua execução.": "Permite que el operador agregue más tiempo para dorar la comida después de su ejecución.",
    "menus.Permite que o operador edite grupos de receitas diretamente da tela inicial.": "Permite que el operador edite grupos de recetas directamente desde la pantalla principal.",
    "menus.Copiar grupos": "Copiar grupos",
    "menus.Excluir grupos": "Eliminar grupos",
    "menus.Copiar": "Copiar",
    "menus.Selecione grupos para copiar": "Seleccione grupos para copiar",
    "menus.Selecione o destino dos grupos": "Seleccione el destino de los grupos",
    "menus.Colar": "Pegar",
    "menus.Deseja cancelar a cópia e envio de grupos para os menus?": "¿Desea cancelar la copia y el envío de grupos a los menús?",
    "menus.Grupos colados com sucesso": "{count, plural, one {¡Grupo pegado con éxito!} other {¡Grupos pegados con éxito!}}",
    "menus.Copiar receitas": "Copiar recetas",
    "menus.Selecione receitas para copiar": "Seleccione recetas para copiar",
    "menus.Selecione o destino das receitas": "Seleccione el destino de las recetas",
    "menus.Deseja cancelar a cópia e envio de receitas para os grupos?": "¿Desea cancelar la copia y el envío de recetas a los grupos?",
    "menus.Receitas coladas com sucesso": "{count, plural, one {¡Receta pegada con éxito!} other {¡Recetas pegadas con éxito!}}",
    "menus.Converter para C-MAX EVO": "Convertir a C-MAX EVO",
    "menus.Uma cópia deste menu, adaptada para o C-MAX EVO, será criada. Recomendamos que revise cuidadosamente todos os parâmetros dos passos e atualize as receitas com novas imagens, se julgar necessário.": "Se creará una copia de este menú, adaptada al C-MAX EVO. Recomendamos revisar cuidadosamente todos los parámetros de los pasos y actualizar las recetas con nuevas imágenes si es necesario.",
    "menus.Menu convertido com sucesso!": "¡Menú convertido con éxito!",
    "menus.Não foi possível converter o menu. Tente novamente mais tarde": "No se pudo convertir el menú. Inténtelo de nuevo más tarde.",
    "menus.O menu está sendo convertido... Aguarde!": "El menú se está convirtiendo... ¡Espere!",
    "menus.Menu incompatível com": "Menú incompatible con",
    "menus.Selecione pelo menos um grupo": "Selecciona al menos un grupo",
    "menus.Selecione pelo menos um menu": "Selecciona al menos un menú",
    "menus.Menu atual": "Menú actual",
    "menus.Copiando grupos": "{count, plural, one {El grupo se está copiando... ¡Espere!} other {Los grupos se están copiando... ¡Espere!}}",
    "menus.Erro ao copiar grupos": "{count, plural, one {No se pudo copiar el grupo. ¡Inténtelo de nuevo más tarde!} other {No se pudieron copiar los grupos. ¡Inténtelo de nuevo más tarde!}}",
    "menus.Procurar pelo nome do menu": "Buscar por nombre del menú",
    "menus.Escolha um grupo de destino para cada menu selecionado": "Elija un grupo de destino para cada menú seleccionado!",
    "menus.Copiando receitas": "{count, plural, one {La receta está siendo copiada... ¡Espere!} other {Las recetas están siendo copiadas... ¡Espere!}}",
    "menus.Erro ao copiar receitas": "{count, plural, one {No se pudo copiar la receta. ¡Inténtelo de nuevo más tarde!} other {No se pudieron copiar las recetas. ¡Inténtelo de nuevo más tarde!}}",
    "menus.SELECIONE GRUPOS PARA EXCLUIR": "SELECCIONE GRUPOS PARA ELIMINAR",
    "menus.Padeiro noturno": "Panadero nocturno",
    "menus.Permite programar o início (pré-aquecimento) de uma receita específica ou informada manualmente (Modo Manual), sem a necessidade de presença de um operador no local.": "Permite programar el inicio (precalentamiento) de una receta específica o ingresada manualmente (Modo Manual), sin necesidad de la presencia de un operador en el lugar.",
    "menus.Vaporizador": "Vaporizador",
    "menus.Editar receitas": "Editar recetas",
    "menus.Permite que o operador edite receitas diretamente da tela inicial.": "Permite que el operador edite recetas directamente desde la pantalla de inicio.",
    "menus.Preencha o nome da receita": "Complete el nombre de la receta",
    "menus.Tempo nível": "Nivel de tiempo",
    "menus.Fermentadora": "Fermentadora",
    "menus.0 ou 5 a 59s": "0 o de 5 a 59 s",
    "menus.Informe o tempo para aquecer mais":
    "Indique el tiempo para calentar más",
    "menus.Informe o tempo para dourar mais":
    "Indique el tiempo para dorar más",
    "menus.Informe o tempo para aquecer e dourar mais":
    "Indique el tiempo para calentar y dorar más",
    "menus.Selecione uma imagem": "Seleccione una imagen",
    "menus.*Para criar receitas para fornos sem conectividade, crie um menu e então as receitas.": "*Para crear recetas para hornos sin conectividad, cree un menú y luego las recetas.",
    "menus.CONVERTER": "CONVERTIR",
    "menus.Converter para FIT": "Convertir a FIT",
    "menus.Selecione pelo menos um modelo FIT": "Seleccione al menos un modelo FIT",
    "menus.O menu está sendo convertido para FIT... Aguarde!": "El menú se está convirtiendo a FIT... ¡Espere!",
    "menus.{count} menu(s) convertido(s) com sucesso para FIT!": "{count} menú(s) convertidos con éxito a FIT!",
    "menus.Alguns menus foram convertidos, mas houve falha em: {models}": "Algunos menús fueron convertidos, pero hubo fallos en: {models}",
    "menus.Converter para outro FIT": "Convertir a otro FIT",
    "menus.Uma cópia deste menu será criada para cada modelo FIT selecionado, mantendo configurações, grupos, receitas e passos.": "Se creará una copia de este menú para cada modelo FIT seleccionado, manteniendo configuraciones, grupos, recetas y pasos.",
    "menus.Uma cópia deste menu será criada para cada modelo FIT selecionado, mantendo configurações, grupos, receitas e passos. No entanto, como cada forno possui dimensões e características específicas, recomendamos revisar e ajustar os parâmetros para garantir o melhor desempenho e resultado em cada equipamento. Selecione o modelo da linha FIT para qual deseja converter o menu." : "Se creará una copia de este menú para cada modelo FIT seleccionado, manteniendo configuraciones, grupos, recetas y pasos. Sin embargo, como cada horno posee dimensiones y características específicas, recomendamos revisar y ajustar los parámetros para garantizar el mejor rendimiento y resultado en cada equipo. Seleccione el modelo de la línea FIT al que desea convertir el menú.",
    
    //COOKBOOK
    "cookbook.RECEITAS DISPONÍVEIS": "RECETAS DISPONIBLES",
    "cookbook.RECEITAS SALVAS": "RECETAS GUARDADAS",
    "cookbook.ENVIAR PARA MENU": "ENVIAR AL MENÚ",
    "cookbook.SALVAR": "GUARDAR",
    "cookbook.salvar": "guardar",
    "cookbook.Filtrar por": "Filtrar por",
    "cookbook.Procurar receita do cookbook": "Buscar receta en el Cookbook",
    "cookbook.Equipamento": "Equipo",
    "cookbook.Ingrediente principal": "Ingrediente principal",
    "cookbook.Tipo de prato": "Tipo de comida",
    "cookbook.Região": "Región",
    "cookbook.Pré-aquecimento": "Precalentamiento",
    "cookbook.Procurar receita": "Buscar receta",
    "cookbook.Menu": "Menú",
    "cookbook.ENVIAR": "ENVIAR",
    "cookbook.Procurar nome do menu": "Buscar por nombre de menú",
    "cookbook.Escolha um grupo deste menu": "Elegir un grupo de este menú",
    "cookbook.Selecionar grupo": "Seleccionar grupo",
    "cookbook.Tivemos um problema. Tente novamente mais tarde": "Tuvimos un problema. Inténtalo de nuevo más tarde",
    "cookbook.Receita adicionada com sucesso!": "Receta añadida exitosamente!",
    "cookbook.Não foi possível adicionar a receita. Tente novamente mais tarde": "No fue posible agregar la receta. Inténtalo de nuevo más tarde",
    "cookbook.Selecione um menu e um grupo para enviar esta receita": "Selecciona un menú y un grupo para enviar esta receta",
    "cookbook.Selecione o modelo do equipamento primeiro": "Selecciona primero el modelo del equipo",
    "cookbook.Grupo": "Grupo",
    "cookbook.Não foi possível salvar os passos da receita": "No fue posible guardar los pasos de la receta",
    "cookbook.Bovina": "Carne de res",
    "cookbook.Frango": "Pollo",
    "cookbook.Ovos": "Huevos",
    "cookbook.Pães": "Pan",
    "cookbook.Peixes": "Pescado",
    "cookbook.Queijo": "Queso",
    "cookbook.Suína": "Cerdo",
    "cookbook.Vegetais": "Vegetales",
    "cookbook.Outros": "Otros",
    "cookbook.Entradas/aperitivos": "Entradas",
    "cookbook.Principais": "Principal",
    "cookbook.Snacks": "Aperitivos",
    "cookbook.Pizzas": "Pizzas",
    "cookbook.Massas": "Pastas",
    "cookbook.Acompanhamentos": "Acompañamientos",
    "cookbook.Sobremesas": "Postres",
    "cookbook.Manhã": "Desayuno",
    "cookbook.Padaria": "Panadería",
    "cookbook.Todos": "Todos",
    "cookbook.Não atribuir origem": "No atribuir origen",
    "cookbook.Brasil": "Brasil",
    "cookbook.Alemanha": "Alemania",
    "cookbook.França": "Francia",
    "cookbook.Rússia": "Rusia",
    "cookbook.China": "China",
    "cookbook.Japão": "Japón",
    "cookbook.Itália": "Italia",
    "cookbook.Egito": "Egipto",
    "cookbook.Grécia": "Grecia",
    "cookbook.Argentina": "Argentina",
    "cookbook.África": "África",
    "cookbook.Estados Unidos": "Estados Unidos",
    "cookbook.Coreia": "Corea",
    "cookbook.Turquia": "Turquía",
    "cookbook.Ideal para": "Ideal para",
    "cookbook.Polônia": "Polonia",
    "cookbook.Sanduíches": "Sándwiches",
    "cookbook.A receita não foi adicionada ao menu pois não há grupos criados":
    "La receta no se agregó al menú porque no hay grupos creados.",
    "cookbook.Nova Receita": "Nueva receta",
    
    //EQUIPAMENTOS
    "equipment.equipamentos": "Equipos",
    "equipment.procurar equipamento": "Buscar equipo o usuario",
    "equipment.adicionar equipamento": "Agregar equipo",
    "equipment.atualizar equipamento": "Actualizar equipo",
    "equipment.+ equipamentos": "Equipo",
    "equipment.buscar equipamento": "Buscar equipo",
    "equipment.Desvincular": "Desvincular",
    "equipment.Editar": "Editar",
    "equipment.sem conteúdo": "AQUÍ AÚN NO HAY EQUIPOS :(",
    "equipment.description.sem conteúdo": "Haga clic en el botón Agregar equipo, ubicado en la esquina superior derecha, y vincule sus hornos.",
    "equipment.editar equipamento": "editar equipo",
    "equipment.equipamento editado com sucesso!": "Equipo editado exitosamente!",
    "equipment.não foi possível editar o equipamento. Tente novamente mais tarde": "No fue posible editar el equipo. Inténtalo de nuevo más tarde",
    "equipment.Menu exportado com sucesso!": "Menú exportado exitosamente!",
    "equipment.Não foi possível exportar o menu. Tente novamente mais tarde": "No fue posible exportar el menú. Inténtalo de nuevo más tarde",
    "equipment.Selecione pelo menos um equipamento para enviar o menu": "Selecciona al menos un equipo para enviar el menú",
    "equipment.Informações do menu": "Información del menú",
    "equipment.Procurar receita ou grupo": "Buscar receta o grupo",
    "equipment.Grupo": "Grupo",
    "equipment.Grupos de equipamentos": "Grupos de equipos",
    "equipment.Receita": "Receta",
    "equipment.Quantidade": "Cantidad",
    "equipment.Receitas mais preparadas no equipamento durante o período": "Recetas más preparadas en el equipo durante el período",
    "equipment.Informações de limpeza": "Información de limpieza",
    "equipment.Data da limpeza": "Fecha de limpieza",
    "equipment.Hora da limpeza": "Hora de limpieza",
    "equipment.nome": "Nombre",
    "equipment.modelo": "Modelo",
    "equipment.categoria": "Categoría",
    "equipment.loja": "Tienda",
    "equipment.desvincular equipamento": "Desvincular equipo",
    "equipment.unlink.paragrafo 1": "¿Deseas desvincular el equipo de la plataforma IOK?",
    "equipment.unlink.paragrafo 2": "Al hacerlo, no será posible gestionar tus configuraciones y menú a través de la plataforma, a menos que vuelvas a vincular el equipo siguiendo las instrucciones de conexión.",
    "equipamento desvinculado com sucesso!": "Equipo desvinculado exitosamente!",
    "equipment.ocorreu um erro. Tente novamente mais tarde": "Se ha producido un error. Inténtalo de nuevo más tarde.",
    "equipment.sim": "Sí",
    "equipment.não": "No",
    "equipment.Encerrar acesso remoto": "Finalizar acceso remoto",
    "equipment.Horas sem limpeza": "Horas sin limpieza",
    "equipment.Histórico de eventos": "Historial de eventos",
    "equipment.Histórico de eventos do forno": "Historial de eventos del horno",
    "equipment.Histórico de eventos da fermentadora": "Historial de eventos de la fermentadora",
    "equipment.Receitas executadas": "Recetas ejecutadas",
    "equipment.Hoje": "Hoy",
    "equipment.Tempo de porta aberta": "Tiempo de puerta abierta",
    "equipment.Tempo médio aproximado": "Tiempo medio aproximado",
    "equipment.Filtrar eventos": "Filtrar eventos",
    "equipment.Evento": "Evento",
    "equipment.Data": "Fecha",
    "equipment.ERRO SENSOR RI": "Error con el sensor de resistencia inferior",
    "equipment.ERRO COM INV. DE FREQ.": "Error con el inversor de frecuencia",
    "equipment.ERRO MAGNETRON": "Error del magnetrón",
    "equipment.ERRO SENSOR CAMARA": "Error con el sensor de la cámara",
    "equipment.ERRO CAN": "Error CAN",
    "equipment.Erro INVERSOR DE FREQUENCIA": "Error del inversor de frecuencia",
    "equipment.ERRO DO MODELO DO EQUIPAMENTO": "Error de modelo del equipo",
    "equipment.ERRO PAINEL": "Error de panel",
    "equipment.ERRO INV.FREQ.STATUS": "Estado de error del inversor de frecuencia",
    "equipment.ERRO SENSOR BOARD": "Error del sensor de la placa",
    "equipment.ERRO ENERGY": "Error de energía",
    "equipment.ERRO I2C": "Error I2C",
    "equipment.EQUIPAMENTO LIGADO": "Equipo encendido",
    "equipment.EQUIPAMENTO DESLIGADO": "Equipo apagado",
    "equipment.Plataforma": "Plataforma",
    "equipment.Forno": "Horno",
    "equipment.Origem": "Origen",
    "equipment.Locais": "Ubicaciones",
    "equipment.não foi possível carregar as entidades": "No fue posible cargar las entidades",
    "equipment.conceder acesso remoto a": "Conceder acceso remoto a",
    "equipment.atualizar software": "actualizar software",
    "equipment.suporte": "Soporte",
    "equipment.PIN": "PIN",
    "equipment.nome do equipamento": "Nombre del equipo",
    "equipment.vinculado à loja": "Vinculado a la tienda",
    "equipment.cadastrar loja": "Registrar tienda",
    "equipment.informe o PIN do forno": "Ingresa el PIN del horno",
    "equipment.preencha o PIN do forno": "Completa el PIN del horno",
    "equipment.adicione um nome para facilitar seu reconhecimento": "Añade un nombre para reconocerlo más fácilmente",
    "equipment.preencha o nome do equipamento": "Completa el nombre del equipo",
    "equipment.selecionar": "Seleccionar",
    "equipment.nome fantasia": "Nombre fantástico",
    "equipment.informe o nome fantasia": "Ingresa el nombre fantástico",
    "equipment.preencha o nome fantasia": "Completa el nombre fantástico",
    "equipment.CNPJ": "CNPJ",
    "equipment.XX.XXX.XXX/0001.XX": "XX.XXX.XXX/0001.XX",
    "equipment.preencha o CNPJ": "Completa el CNPJ",
    "equipment.CEP": "Código postal",
    "equipment.00000-000": "00000-000",
    "equipment.preencha o CEP": "Completa el código postal",
    "equipment.cidade": "Ciudad",
    "equipment.informe a cidade": "Ingresa la ciudad",
    "equipment.preencha a cidade": "Completa la ciudad",
    "equipment.UF": "Estado",
    "equipment.bairro": "Barrio",
    "equipment.informe o bairro": "Ingresa el barrio",
    "equipment.endereço": "Dirección",
    "equipment.informe o seu endereço": "Ingresa tu dirección",
    "equipment.preencha o seu endereço": "Completa tu dirección",
    "equipment.Nº": "Nro.",
    "equipment.equipamento cadastrado com sucesso!": "!Equipo registrado exitosamente!",
    "equipment.ocorreu um erro": "Se ha producido un error",
    "equipment.preencha o modelo": "Completa el modelo",
    "equipment.selecione uma categoria": "Selecciona una categoría",
    "equipment.selecione uma loja": "Seleccionar una tienda",
    "equipment.preencha o bairro": "Completa el barrio",
    "equipment.não foi possível cadastrar o equipamento. Tente novamente mais tarde": "No fue posible registrar el equipo. Inténtalo de nuevo más tarde",
    "equipment.loja cadastrada com sucesso": "Tienda registrada exitosamente",
    "equipment.não foi possível cadastrar a loja. Tente novamente mais tarde": "No fue posible registrar la tienda. Inténtalo de nuevo más tarde",
    "equipment.equipment": "Equipos",
    "equipment.stores": "Tiendas",
    "equipment.search equipment": "Buscar equipo",
    "equipment.add equipment": "Agregar equipo",
    "equipment.update equipment": "Actualizar equipo",
    "equipment.plus equipment": "Equipo",
    "equipment.Procurar equipamento": "Buscar equipo",
    "equipment.EQUIPAMENTOS": "EQUIPO",
    "equipment.Atualizar equipamento": "Actualizar equipo",
    "equipment.Atualizar equipamentos": "Actualizar equipo",
    "equipment.confirmar": "Confirmar",
    "equipment.Selecione os modelos que deseja atualizar:": "Selecciona los modelos que deseas actualizar",
    "equipment.Como deseja realizar a atualização?": "¿Cómo deseas proceder con la actualización?",
    "equipment.Enviar atualização pela plataforma (internet)": "Enviar actualización a través de la plataforma (internet)",
    "equipment.Salvar arquivo de atualização no dispositivo": "Guardar archivo de actualización en el dispositivo",
    "equipment.Linha Express": "Línea Express",
    "equipment.Escolha como deseja realizar a atualização": "Elige cómo deseas proceder con la actualización",
    "equipment.Selecione ao menos um modelo de equipamento para atualizar": "Selecciona al menos un modelo de equipo para actualizar",
    "equipment.Status:": "Estado: ",
    "equipment.Número de série:": "Número de serie",
    "equipment.Número de série": "Número de serie",
    "equipment.Menu:": "Menú",
    "equipment.Menu": "Menú",
    "equipment.Loja:": "Tienda",
    "equipment.End:": "Dirección: ",
    "equipment.Endereço:": "Dirección: ",
    "equipment.Cidade:": "Ciudad: ",
    "equipment.CEP:": "Código postal: ",
    "equipment.Atualização de software enviada com sucesso!": "Actualización de software enviada con éxito!",
    "equipment.Não foi possível enviar a atualização de software. Tente novamente mais tarde": "No fue posible enviar la actualización de software. Inténtalo de nuevo más tarde",
    "equipment.Download realizado com sucesso": "Descarga completada con éxito",
    "equipment.Não foi possível realizar o download. Tente novamente mais tarde": "No fue posible completar la descarga. Inténtalo de nuevo más tarde",
    "equipment.name": "Nombre",
    "equipment.model": "Modelo",
    "equipment.category": "Categoría",
    "equipment.store": "tienda",
    "FIT Express/FIT ST": "FIT Express/FIT ST",
    "Copa/Single Mag/Rocket": "Copa/Single Mag/Rocket",
    "Forza STi": "Forza STi",
    "TSi": "TSi",
    "FIT Express": "FIT Express",
    "FIT ST": "FIT ST",
    "equipment.Preencha o nome da versão": "Completa el nombre de la versión",
    "equipment.Informe aqui todas as alterações desta nova versão": "Ingresa aquí todos los cambios en esta nueva versión",
    "equipment.Nova versão de software atualizada com sucesso!": "Nueva versión de software actualizada con éxito!",
    "equipment.Informe pelo menos uma mudança nesta versão": "Ingresa al menos un cambio en esta versión",
    "equipment.Falha ao ler o arquivo": "Error al leer el archivo",
    "equipment.selecionar tipo": "seleccionar tipo",
    "equipment.selecione o tipo da versão": "seleccionar tipo de versión",
    "equipment.atualização": "ACTUALIZAR",
    "equipment.Selecione abaixo o que deseja fazer:": "Selecciona a continuación lo que deseas hacer:",
    "equipment.Atualizar meus equipamentos": "Actualizar mi equipo",
    "equipment.Enviar atualização para usuários selecionados": "Enviar actualización a usuarios seleccionados",
    "equipment.ENVIAR": "ENVIAR",
    "equipment.ENVIAR ATUALIZAÇÃO": "ENVIAR ACTUALIZACIÓN",
    "equipment.Selecione os e-mails para os quais deseja enviar a atualização:": "Selecciona los correos electrónicos a los que deseas enviar la actualización:",
    "equipment.A atualização disponibilizada no dia": "La actualización disponible en el día",
    "equipment.referente ao equipamento": "con respecto al equipo",
    "equipment.contempla o seguinte:": "considera lo siguiente:",
    "equipment.Selecionar arquivo para envio": "Seleccionar archivo para enviar",
    "equipment.Por favor, selecione um arquivo .tar": "Por favor, selecciona un archivo .tar",
    "equipment.Selecione o modelo do equipamento:": "Selecciona el modelo del equipo:",
    "equipment.Selecione uma opção": "Selecciona una opción",
    "equipment.Nomeie a versão": "Nombre de la versión",
    "equipment.Clique sobre o arquivo que deseja baixar:": "Haga clic en el archivo que desea descargar:",
    "equipment.Baixar atualização": "Descarga de la actualización",
    "equipment.Versões": "Versiones",
    "equipment.e superiores": "y más alto",
    "FIT Express, FIT ST": "FIT Express, FIT ST",
    "Copa Express, Rocket Express, Copa Single Mag": "Copa Express, Rocket Express, Copa Single Mag",
    "equipment.e": "y",
    "equipment.Últimas versões de software:": "Últimas versiones de software: ",
    "equipment.Você não possui nenhum equipamento desatualizado": "No tienes ningún equipo obsoleto",
    "equipment.grupos": "grupos",
    "equipment.não foi possível carregar os grupos de equipamentos da companhia": "No se pueden cargar los grupos de equipos de la empresa",
    "equipment.vinculado ao grupo": "Vinculado al grupo",
    "equipment.selecione um grupo": "Seleccione un grupo",
    "equipment.cadastrar grupo": "Registrar grupo",
    "equipment.Número de Série": "NS",
    "equipment.Versão": "Versión",
    "equipment.não foi possível cadastrar o equipamento. Selecione ou cadastre um grupo": "No se pudo registrar el equipo. Seleccione o registre un grupo",
    "equipment.CRIE GRUPOS DE EQUIPAMENTOS!": "¡CREA GRUPOS DE EQUIPOS!",
    "equipment.Para que os usuários vinculados à conta possam visualizar os equipamentos você precisa:": "Para que los usuarios vinculados a la cuenta puedan visualizar el equipo es necesario:",
    "equipment.1) Criar grupo(s);": "1) Crear grupo(s);",
    "equipment.2) Atribuir equipamento(s) ao grupo;": "2) Asignar equipo(s) al grupo;",
    "equipment.3) Atribuir usuário(s) ao grupo.": "3) Asigne usuarios al grupo.",
    "equipment.Status software": "Estado del software",
    "equipment.Status menu": "Estado del menú",
    "equipment.Pendente": "Pendiente",
    "equipment.Aceito": "Aceptado",
    "equipment.Recusado": "Rechazado",
    "equipment.Atualizar software": "Actualizar software",
    "equipment.Deseja enviar a atualização para o equipamento selecionado?": "¿Desea enviar la actualización al equipo seleccionado?",
    "equipment.Companhia": "Compañía",
    "equipment.Exportar menu": "Menú exportar",
    "equipment.companhias": "compañías",
    "equipment.Nome da companhia": "Nombre de empresa",
    "equipment.Procurar equipamento, usuário ou companhia": "Búsqueda por equipo, usuario o empresa",
    "equipment.Versão da power": "Versión de power",
    "equipment.AINDA NÃO HÁ DADOS DE RECEITAS AQUI :(": "AQUÍ AÚN NO HAY DATOS DE LA RECETA :(",
    "equipment.AINDA NÃO HÁ DADOS DE LIMPEZAS AQUI :(": "AQUÍ AÚN NO HAY DATOS DE LIMPIEZA :(",
    "equipment.AINDA NÃO HÁ DADOS DE EVENTOS AQUI :(": "AQUÍ NO HAY DATOS DEL EVENTO AÚN :(",
    "ID": "ID",
    "equipment.Hora": "Hora",
    "equipment.EVENTOS MAIS OCORRIDOS NO EQUIPAMENTO DURANTE O PERÍODO": "EVENTOS MÁS OCURRIDOS EN EL EQUIPO DURANTE EL PERIODO",
    "equipment.hour": "h",
    "equipment.minutes": "min",
    "equipment.date format": "DD/MM/AAAA",
    "equipment.preparada": "preparada",
    "equipment.vezes": "veces",
    "equipment.vez": "vez",
    "equipment.Ver": "Ver",
    "equipment.Os dados são mantidos pela plataforma pelo tempo necessário para suporte, manutenção e evolução dos produtos.": "Los datos se conservan en la plataforma durante el tiempo necesario para el soporte, el mantenimiento y la evolución de los productos.",
    "equipment.Ligado": "Encendido",
    "equipment.Desligado": "Apagado",
    "equipment.CAN ERROR": "Error de CAN",
    "equipment.CAMERA SENSOR ERROR": "Error en el sensor de la cámara",
    "equipment.STEAM/RI SENSOR ERROR": "Error del sensor RI",
    "equipment.PROBE 1 ERROR": "Alerta de sonda 1",
    "equipment.PROBE 2 ERROR": "Alerta de sonda 2",
    "equipment.PROBE 3 ERROR": "Alerta de sonda 3",
    "equipment.PROBE 4 ERROR": "Alerta de sonda 4",
    "equipment.PROBE 5 ERROR": "Alerta de sonda 5",
    "equipment.PROBE 6 ERROR": "Alerta de sonda 6",
    "equipment.GENERAL PROBE ERROR": "Error general de sonda",
    "equipment.WATER LACK ERROR": "Alerta de nivel bajo de agua",
    "equipment.HIGH PANEL TEMPERATURE ERROR": "Alerta de temperatura alta del panel",
    "equipment.FREQUENCY INVERTER GENERAL ERROR": "Error del variador de frecuencia",
    "equipment.FREQUENCY INVERTER COMMUNICATION ERROR": "Alerta de comunicación en el variador de frecuencia",
    "equipment.FREQUENCY INVERTER STATUS ERROR": "Alerta de estado del variador de frecuencia",
    "equipment.CLEANING NOT COMPLETED ERROR": "Alerta de limpieza incompleta",
    "equipment.MAGNETRON ERROR": "Alerta del magnetrón",
    "equipment.EQUIPMENT FAMILY/MODEL ERROR": "Error de modelo de equipo",
    "equipment.BOARD TEMPERATURE SENSOR ERROR": "Alerta del sensor de temperatura de la placa",
    "equipment.ENERGY MODULE ERROR": "Error del módulo de energía",
    "equipment.POWER BOARD I2C BUS ERROR": "Error en la placa de alimentación",
    "equipment.GAS SYSTEM ERROR": "Error de gas",
    "equipment.VERY HIGH PANEL TEMPERATURE ERROR": "Error de temperatura del panel muy alta",
    "equipment.POWER ON": "Encendido",
    "equipment.POWER OFF": "Apagado",
    "equipment.DOOR OPENED": "Puerta abierta",
    "equipment.DOOR CLOSED": "Puerta cerrada",
    "equipment.CLEANING CANCELED ERROR": "Sanitización cancelada por usuario",
    "equipment.PIN não encontrado. Por favor, verifique e tente novamente": "PIN no encontrado. Por favor revisa e intenta de nuevo",
    "equipment.Ultracongeladores": "Abatidores",
    "equipment.PIN já vinculado a outra conta": "El PIN ya está vinculado a otra cuenta",
    "equipment.Equipamento já cadastrado nesta conta": "El equipo ya está registrado en esta cuenta",
    "equipment.Não foi possível validar o PIN. Tente novamente": "No se pudo validar el PIN. Inténtalo de nuevo",
    "equipment.Modelo definido pelo equipamento": "Definido por el equipo",
    "equipment.Número de série offline inválido": "Introduce siete dígitos, sin espacios ni cero inicial",
    "equipment.Número de série já cadastrado": "Número de serie ya registrado",
    "equipment.Online": "Encendido",
    "equipment.Offline": "Apagado",
    "equipment.Exibir apenas eventos": "Mostrar solo eventos",
    "equipment.Endereço": "Dirección",
    "equipment.EQUIPMENT CONNECTED TO THE PLATFORM": "Equipo conectado a la plataforma",
    "equipment.EQUIPMENT DISCONNECTED FROM THE PLATFORM": "Equipo desconectado de la plataforma",
    "equipment.MENU RECEIVED FROM THE PLATFORM": "Menú de la plataforma aceptado por el usuario",
    "equipment.MENU REJECTED BY THE USER": "Menú de la plataforma rechazado por el usuario",
    "equipment.CONNECTED TO THE INTERNET": "Conectado a Internet",
    "equipment.DISCONNECTED FROM THE INTERNET": "Desconectado de internet",
    "equipment.Infelizmente, não há versões compatíveis com este equipamento que realizem o envio de dados.": "Lamentablemente no existen versiones compatibles con este equipo que puedan enviar datos.",
    "equipment.O equipamento": "El equipo",
    "equipment.deve ser atualizado para a versão mais recente de software para que passe a enviar os dados para a plataforma": "debe actualizarse a la versión más reciente del software para comenzar a enviar datos a la plataforma",
    "equipment.Versão do seu equipamento": "Versión de su equipo",
    "equipment.Versão disponível": "Versión disponible",
    "equipment.Selecione abaixo como deseja enviar a atualização para seu equipamento": "Seleccione abajo cómo desea enviar la actualización a su equipo",
    "equipment.Salvar no dispositivo": "Guardar en el dispositivo",
    "equipment.Enviar pela internet": "Enviar por internet",
    "equipment.Cliente": "Cliente",
    "equipment.NÚMERO DE SÉRIE NÃO ENCONTRADO": "NÚMERO DE SERIE NO ENCONTRADO",
    "equipment.BUSCAR": "BUSCAR",
    "equipment.ACESSADOS RECENTEMENTE": "ACCESO RECIENTE",
    "equipment.SEM BUSCAS RECENTES": "NO HAY BÚSQUEDAS RECIENTES",
    "equipment.description.SEM BUSCAS RECENTES": "Utilice el número de serie para buscar equipos.",
    "equipment.Procurar equipamento pelo número de série": "Buscar equipos por número de serie",
    "equipment.AIR FILTER CLEANING COMPLETED": "Limpieza del filtro de aire completa",
    "equipment.AIR FILTER CLEANING REJECTED": "Limpieza del filtro de aire rechazada",
    "equipment.CATALYTIC FILTER CLEANING COMPLETED": "Limpieza del filtro catalítico completada",
    "equipment.CATALYTIC FILTER CLEANING REJECTED": "Limpieza del filtro catalítico rechazada",
    "equipment.ID do equipamento": "ID del equipo",
    "equipment.Todo equipamento deve ser vinculado a um grupo. Selecione um grupo da lista ou cadastre um novo clicando em + Cadastrar grupo.": "Todo el equipo debe estar vinculado a un grupo. Seleccione un grupo de la lista o registre uno nuevo haciendo clic en + Registrar grupo.",
    "equipment.Nomeie seu forno": "Ponle nombre a tu horno",
    "equipment.Para visualizar o PIN, acesse nas configurações do equipamento a Plataforma Virtual IOK.": "Para visualizar el PIN acceda a la Plataforma Virtual IOK en la configuración del equipo.",
    "equipment.localização": "ubicación",
    "equipment.AINDA NÃO HÁ NENHUMA LOCALIZAÇÃO CADASTRADA :(": "AÚN NO HAY UBICACIÓN REGISTRADA :(",
    "equipment.description.AINDA NÃO HÁ NENHUMA LOCALIZAÇÃO CADASTRADA :(": "Haga clic en el botón ubicado en la esquina superior derecha y agregue ubicaciones.",
    "equipment.Procurar empresa ou local": "Buscar empresa o ubicación",
    "equipment.Adicionar localização": "Agregar Direccion",
    "equipment.Adicionar": "Agregar",
    "equipment.espaço": "Espacio",
    "equipment.local": "Local",
    "equipment.EXCLUIR LOCALIZAÇÃO": "BORRAR UBICACIÓN",
    "equipment.Você deseja excluir esta localização?": "¿Quieres eliminar esta ubicación?",
    "equipment.Ao fazer isso, os equipamentos atrelados à ela não exibirão nenhuma localização, sendo necessário informar um novo local para eles.": "Al hacer esto, los equipos vinculados al mismo no mostrarán ninguna ubicación, por lo que será necesario proporcionarles una nueva ubicación.",
    "equipment.Localização deletada com sucesso!": "¡Ubicación eliminada correctamente!",
    "equipment.Erro ao deletar a localização. Tente novamente mais tarde": "Error al eliminar la ubicación. Vuelve a intentarlo más tarde",
    "equipment.Não foi possivel deletar a localização": "No se puede eliminar la ubicación",
    "equipment.Localização adicionada com sucesso!": "¡Ubicación agregada exitosamente!",
    "equipment.Não foi possível adicionar a localização. Tente novamente mais tarde": "No se puede agregar la ubicación. Vuelve a intentarlo más tarde",
    "equipment.Nome do espaço": "Nombre del espacio",
    "equipment.Informe o nome do espaço": "Introduce el nombre del espacio",
    "equipment.Preencha o nome do espaço": "Completa el nombre del espacio",
    "equipment.país": "País",
    "equipment.Endereço (rua, avenida, rodovia)": "Dirección (calle, avenida, carretera)",
    "equipment.Nº/Km": "Nº/Km",
    "equipment.informe o país": "Ingrese al pais",
    "equipment.preencha o país": "Complete el país",
    "equipment.Localização editada com sucesso!": "¡Ubicación editada correctamente!",
    "equipment.Não foi possível editar a localização. Tente novamente mais tarde": "No se puede editar la ubicación. Vuelve a intentarlo más tarde",
    "equipment.Editar localização": "Editar ubicación",
    "equipment.Pico de preparações": "Pico de preparaciones",
    "equipment.informações da semana": "información de la semana",
    "equipment.horários de pico": "horas pico",
    "equipment.horário de pico": "hora pico",
    "equipment.preparações do dia": "preparaciones del día",
    "equipment.Horário": "Tiempo",
   "equipment.Preparações": "Preparaciones",
    "equipment.recipeTable.recipe": "Receta",
    "equipment.recipeTable.origin": "Ori.",
    "equipment.recipeTable.executions": "Ejec.",
    "equipment.recipeTable.lastExecution": "Última ejecución",
    "equipment.dia selecionado": "día seleccionado",
    "equipment.Vinculação IOK": "Encuadernación IOK",
    "equipment.Última preparação": "Última preparación",
    "equipment.A limpeza adequada e diária do forno auxilia em seu funcionamento correto e impacta na garantia.": "La limpieza adecuada y diaria del horno ayuda a que funcione correctamente e impacta en la garantía.",
    "equipment.Total de limpezas realizadas:": "Limpieza total realizada:",
    "equipment.Limpezas não concluídas:": "Limpiezas no completadas:",
    "equipment.Desde a vinculação do forno a IOK": "De conectar el horno a IOK",
    "equipment.Equipamento ligado há:": "Equipo encendido desde hace:",
    "equipment.Total de receitas preparadas:": "Total de recetas preparadas:",
    "equipment.Receitas preparadas": "Recetas preparadas",
    "equipment.Aberturas de porta": "Aperturas de puertas",
    "equipment.Desde a última vez que o forno foi ligado": "Desde la última vez que se encendió el horno",
    "equipment.Preparação": "Preparación",
    "equipment.Nenhuma localização criada": "No se han creado ubicaciones",
    "equipment.Acesso remoto": "Acceso remoto",
    "equipment.Informe o ID da empresa que poderá acessar remotamente seu forno. Use ; para separar IDs.": "Ingrese el ID de la empresa que puede acceder remotamente a su horno. Usar ; para separar identificaciones.",
    "equipment.O acesso remoto permite que as empresas selecionadas enviem menus e atualizações para seu equipamento.": "El acceso remoto permite a empresas seleccionadas enviar menús y actualizaciones a su equipo.",
    "equipment.Concedo acesso remoto à Prática oficial.": "Concedo acceso remoto a la Prática oficial.",
    "equipment.Deseja selecionar outros equipamentos vinculados à sua conta para conceder acesso remoto a eles?": "¿Quieres seleccionar otros dispositivos vinculados a tu cuenta para otorgarles acceso remoto?",
    "equipment.Selecione abaixo os equipamentos para os quais deseja conceder acesso remoto à": "Seleccione a continuación el equipo al que desea otorgar acceso remoto al",
    "equipment.Acesso remoto concedido com sucesso!": "¡Acceso remoto concedido con éxito!",
    "equipment.Selecione pelo menos um equipamento": "Seleccione al menos un dispositivo",
    "equipment.Não foi possível editar os equipamentos. Tente novamente mais tarde": "No se puede editar el equipo. Vuelve a intentarlo más tarde",
    "equipment.Solicitar atendimento": "Solicitar servicio",
    "equipment.Relate um problema": "Informar un problema",
    "equipment.Descreva aqui o problema de seu equipamento": "Describe aquí el problema de tu equipo",
    "equipment.Não foi possível enviar sua solicitação de atendimento. Tente mais tarde": "No pudimos enviar su solicitud de servicio. Inténtalo más tarde",
    "equipment.Solicitação técnica enviada com sucesso!": "¡Solicitud técnica enviada exitosamente!",
    "equipment.Enviar": "Enviar",
    "equipment.Solicitação de atendimento": "Solicitud de servicio",
    "equipment.Informações do magnetron": "Información del magnetrón",
    "equipment.Vida útil aproximada": "Vida útil aproximada",
    "equipment.MAGNETRON USAGE HOURS": "Horas de uso del magnetrón",
    "equipment.Filtros": "Filtros",
    "equipment.Filtrar": "Filtrar",
    "equipment.Limpar filtros": "Limpiar filtros",
    "equipment.Procurar por modelo, versão ou país": "Buscar por modelo, versión o país",
    "equipment.Procurar equipamento, NS, modelo, versão ou país": "Buscar equipo, NS, modelo, versión o país",
    "equipment.Atendimento": "Servicio",
    "equipment.Eventos mais ocorridos no equipamento durante o período": "Eventos que más ocurrieron en el equipo durante el período",
    "equipment.EQUIPAMENTO SEM NÚMERO DE SÉRIE": "EQUIPO SIN NÚMERO DE SERIE",
    "equipment.Os seguintes IDs não pertencem a uma companhia do tipo 'Distribuidor' e foram removidos": "Los siguientes IDs no pertenecen a una empresa del tipo 'Distribuidor' y han sido eliminados",
    "equipment.BAIXAR VERSÕES": "DESCARGAR VERSIONES",
    "equipment.Compatível com todas as versões da IHM.": "Compatible con todas las versiones de HMI.",
    "equipment.Compatível apenas com a versão 2.0.0C da Power.": "Compatible únicamente con la versión Power 2.0.0C.",
    "equipment.Procurar evento": "Buscar evento",
    "equipment.Forno conectado": "Horno conectado",
    "equipment.Limpeza de filtro de ar": "Limpieza de filtro de aire",
    "equipment.Limpeza de filtro catalítico": "Limpieza de filtro catalítico",
    "equipment.Forno ligado": "Horno encendido",
    "equipment.Inversor de frequência": "Inversor de frecuencia",
    "equipment.Temperatura de painel": "Temperatura del panel",
    "equipment.Sensor da câmara": "Sensor de cámara",
    "equipment.Magnetron": "Magnetrón",
    "equipment.Power": "Power",
    "equipment.Informações de menu": "Información de menú",
    "equipment.Limpeza": "Limpieza",
    "equipment.Limpeza realizada": "Limpieza realizada",
    "equipment.Limpeza recomendada": "Limpieza recomendada",
    "equipment.O equipamento já está utilizando a versão mais recente do software.": "El equipo ya está utilizando la versión más reciente del software.",
    "equipment.Atenção: o cálculo da vida útil do magnetron não considera o tempo de uso anterior à versão F1.1.0.": "Atención: el cálculo de la vida útil del magnetrón no considera el tiempo de uso anterior a la versión F1.1.0.",
    "equipment.Equipamentos com erro": "Equipos con errores",
    "equipment.Em breve você terá acesso a dados importantes enviados pelo forno, como horário de pico, receitas mais executadas, histórico de higienizações, eventos ocorridos e mais! Lembre-se de manter seu equipamento sempre atualizado com as novas versões disponíveis na plataforma.":
    "¡Pronto tendrás acceso a datos importantes enviados por el horno, como horas pico, recetas más ejecutadas, historial de limpieza, eventos ocurridos y más! Recuerda mantener tu equipo siempre actualizado con las nuevas versiones disponibles en la plataforma.",
    "equipment.Para que a execução da limpeza seja registrada no equipamento e enviada à plataforma, é necessário seguir o passo a passo completo do procedimento no forno. Não é obrigatório assistir aos vídeos dos passos, quando disponíveis.":
    "Para que la limpieza quede registrada en el equipo y enviada a la plataforma, es necesario seguir el procedimiento completo paso a paso en el horno. No es obligatorio ver vídeos de los pasos, cuando estén disponibles.",
    "equipment.Horas de uso": "Horas de uso",
    "equipment.A contagem das horas de uso do magnetron são realizadas a partir da versão F1.0.6": "El conteo de las horas de uso del magnetrón se realiza a partir de la versión F1.0.6",
    "equipment.A atualização do software leva cerca de 15 minutos. Durante o processo, o forno reiniciará e exibirá uma tela azul até a conclusão. Para evitar falhas, mantenha-o ligado e conectado à internet. Caso opte por atualizar via pen drive, não o remova até a conclusão.": "La actualización del software tarda aproximadamente 15 minutos. Durante el proceso, el horno se reiniciará y mostrará una pantalla azul hasta que finalice. Para evitar fallos, manténgalo encendido y conectado a internet. Si opta por actualizar mediante un dispositivo USB, no lo retire hasta que finalice el proceso.",
    'equipment.Equipamento {name} com software {version} devem ser atualizador via USB. A atualização do software leva cerca de 15 minutos. Durante o processo, o forno reiniciará e exibirá uma tela azul até a conclusão. Para evitar falhas, mantenha-o ligado e conectado à internet. Caso opte por atualizar via pen drive, não o remova até a conclusão.': "El equipo {name} con software {version} debe actualizarse mediante USB. La actualización del software tarda aproximadamente 15 minutos. Durante el proceso, el horno se reiniciará y mostrará una pantalla azul hasta que finalice. Para evitar fallos, manténgalo encendido y conectado a internet. Si opta por actualizar mediante un dispositivo USB, no lo retire hasta que finalice el proceso.",
    "equipment.Observação": "Observación:",
    "equipment.Para versões ST2.0.0 e superiores, o envio de atualização pela plataforma (Wi-fi) seguirá disponibilizado normalmente.": "Para las versiones ST2.0.0 y superiores, la actualización a través de la plataforma (Wi-Fi) seguirá estando disponible normalmente.",
    "equipment.Aqui você encontra informações gerais sobre o equipamento;": "Aquí encontrará información general sobre el equipo;",
    "equipment.Ao clicar nestes botões você consegue solicitar atendimento para seu forno e exportar seus dados em planilhas do Excel;": "Al hacer clic en estos botones, puede solicitar soporte para su horno y exportar sus datos a hojas de cálculo de Excel;",
    "equipment.Nos quadros abaixo você encontra informações detalhadas sobre execuções de receitas;": "En los paneles siguientes encontrará información detallada sobre la preparación de recetas;",
    "equipment.Horário de pico;": "Horas pico;",
    "equipment.Informações referentes a higienização;": "Información relacionada con la limpieza;",
    "equipment.E histórico de eventos;": "Y el historial de eventos;",
    "equipment.Lembre-se de que é necessário selecionar o período do qual deseja visualizar os dados. É possível fazer isso ao clicar sobre o calendário dos quadros e ao selecionar filtros.": "Recuerda que debes seleccionar el periodo del que quieres visualizar los datos. Puedes hacerlo haciendo clic en el calendario de los paneles y seleccionando filtros.",
    "equipment.Baixando o arquivo... Ele estará disponível em breve!": "Descargando el archivo... ¡Estará disponible pronto!",
    "equipment.A contagem das horas de uso do magnetron são realizadas a partir da versão F1.1.0": "El conteo de las horas de uso del magnetrón se realiza a partir de la versión F1.1.0",
    "equipment.Data de fabricação": "Fecha de fabricación",
    "equipment.manutenção": "mantenimiento",
    "equipment.Ao buscar e localizar um número de série, será aberto um canal temporário diretamente com o forno, permitindo o compartilhamento de seus dados de manutenção. Esses dados não serão armazenados na plataforma, sendo necessário realizar uma nova busca sempre que desejado.":
    "Al buscar y localizar un número de serie, se abrirá un canal temporal directamente con el horno, permitiendo el intercambio de sus datos de mantenimiento. Estos datos no se almacenarán en la plataforma, siendo necesario realizar una nueva búsqueda siempre que se desee.",
    "equipment.INFORME UM NÚMERO DE SÉRIE E CLIQUE EM BUSCAR": "INGRESE UN NÚMERO DE SERIE Y HAGA CLIC EN BUSCAR",
    "equipment.Apenas os modelos FIT Express / FIT Single Mag / FIT XL com a versão de software F2.1.0 enviarão dados de manutenção. As informações, principalmente as dos contadores, serão contabilizadas a partir dessa versão.": "Solo los modelos FIT Express / FIT Single Mag / FIT XL con versión de software F2.1.0 enviarán datos de mantenimiento. La información, especialmente la de los contables, se tendrá en cuenta a partir de esta versión.",
    "equipment.Procurar número de série": "Buscar número de serie",
    "equipment.Alerta": "Alerta",
    "equipment.Local": "Ubicación",
    "equipment.Software": "Software",
    "equipment.Forno sem limpeza há": "Horno sin limpieza desde hace",
    "equipment.Horário de pico": "Horario pico",
    "equipment.HP": "HP",
    "equipment.RECIPE STARTED": "Receta iniciada",
    "equipment.RECIPE CANCELED": "Receta cancelada por el usuario",
    "equipment.RECIPE COMPLETED": "Receta finalizada con éxito",
    "equipment.DOOR OPENED RECIPE": "Puerta abierta durante la receta",
    "equipment.DOOR CLOSED RECIPE": "Puerta cerrada durante la receta",
    "equipment.Receitas iniciadas": "Recetas iniciadas",
    "equipment.Receitas concluídas": "Recetas completadas",
    "equipment.Receitas interrompidas": "Recetas interrumpidas",
    "equipment.Total de receitas concluídas:": "Total de recetas completadas:",
    "equipment.TOTAL DE RECEITAS INTERROMPIDAS": "TOTAL DE RECETAS INTERRUMPIDAS",
    "equipment.DOWNLOAD_PROGRESS": "DESCARGANDO ARCHIVO... POR FAVOR ESPERE, PROGRESO: {progress}%",
    "equipment.Informe o número de série do forno": "Ingrese el número de serie del horno",
    "equipment.preencha o número de série do forno": "Complete el número de serie del horno",
    "equipment.NÚMERO DE SÉRIE NÃO CADASTRADO": "NÚMERO DE SERIE NO REGISTRADO",
    "equipment.Número de série não encontrado. Por favor, verifique e tente novamente": "Número de serie no encontrado. Por favor, verifique e vuelva a intentarlo",
    "equipment.Antes de iniciar a atualização, faça o backup das receitas salvas no equipamento para garantir a integridade dos dados. O backup pode ser feito via pen drive ou pela plataforma. Isso permite a recuperação das informações em caso de perda.": "Antes de iniciar la actualización, haga una copia de seguridad de las recetas guardadas en el equipo para garantizar la integridad de los datos. La copia de seguridad puede realizarse mediante una memoria USB o a través de la plataforma. Esto permite la recuperación de la información en caso de pérdida.",
    "equipment.MENU RECEIVED FROM THE PLATFORM BY FORCED METHOD": "Menú recibido de la plataforma mediante actualización forzada",
    "equipment.Nome da receita não encontrado": "Nombre de receta no encontrado",
    "equipment.passos": "{count, plural, one {paso} other {pasos}}",
    "equipment.minAbbreviation": "min",
    "equipment.secAbbreviation": "seg",
    "equipment.status online": "estado en línea",
    "equipment.status offline": "estado fuera de línea",
    "equipment.software accepted": "software aceptado",
    "equipment.menu accepted": "menú aceptado",
    "equipment.software pending": "software pendiente",
    "equipment.menu pending": "menú pendiente",
    "equipment.software refused": "software rechazado",
    "equipment.menu refused": "menú rechazado",
    "equipment.ENCERRAR SESSÃO": "CERRAR SESIÓN",
    "equipment.Configurações": "Configuraciones",
    "equipment.Tempo de preaquecimento": "Tiempo de precalentamiento",
    "equipment.Formato de data": "Formato de fecha",
    "equipment.Formato de hora": "Formato de hora",
    "equipment.Unidade de temperatura": "Unidad de temperatura",
    "equipment.Aquecer/dourar mais": "Calentar/dorar más",
    "equipment.Fabricante": "Fabricante",
    "equipment.Voltagem": "Voltaje",
    "equipment.Introdução": "Introducción",
    "equipment.Modelo": "Modelo",
    "equipment.Motor": "Motor",
    "equipment.Hostname": "Hostname",
    "equipment.STATUS DA OPERAÇÃO": "ESTADO DE OPERACIÓN",
    "equipment.ÚLTIMA LIMPEZA": "ÚLTIMA LIMPIEZA",
    "equipment.VELOCIDADE DO MOTOR": "VELOCIDAD DEL MOTOR",
    "equipment.TENSÃO ATUAL": "VOLTAJE ACTUAL",
    "equipment.Sensores e periféricos": "Sensores y periféricos",
    "equipment.Contadores": "Contadores",
    "equipment.HORAS DE USO DO MOTOR": "HORAS DE USO DEL MOTOR",
    "equipment.HORAS DE USO DO MAGNETRON": "HORAS DE USO DEL MAGNETRÓN",
    "equipment.ABERTURAS DE PORTA": "APERTURAS DE PUERTA",
    "equipment.ATUAÇÃO DO RELE DA POWER": "ACTUACIÓN DEL RELÉ DE POTENCIA",
    "equipment.ATUAÇÃO DO SENSOR DE PORTA": "ACTUACIÓN DEL SENSOR DE PUERTA",
    "equipment.RECEITAS EXECUTADAS": "RECETAS EJECUTADAS",
    "equipment.LIMPEZAS EXECUTADAS": "LIMPIEZAS EJECUTADAS",
    "equipment.HORAS DE USO DO FILTRO CATALÍTICO": "HORAS DE USO DEL FILTRO CATALÍTICO",
    "equipment.HORAS DE USO DO FILTRO DE AR": "HORAS DE USO DEL FILTRO DE AIRE",
    "equipment.CORRENTE DO MAGNETRON": "CORRIENTE DEL MAGNETRÓN",
    "equipment.Erros": "Errores",
    "equipment.Desativado": "Desactivado",
    "equipment.Cozinhando": "Cocinando",
    "equipment.Pré-aquecendo": "Precalentando",
    "equipment.Em espera": "En espera",
    "equipment.Limpando": "Limpiando",
    "equipment.horas": "horas",
    "equipment.Ativado": "Activado",
    "equipment.Erro CAN": "Error CAN",
    "equipment.Erro no sensor de câmara": "Error en el sensor de cámara",
    "equipment.Alerta de temperatura alta no painel": "Alerta de alta temperatura en el panel",
    "equipment.Erro de temperatura alta no painel": "Error de alta temperatura en el panel",
    "equipment.Alerta de comunicação no inversor de frequência": "Alerta de comunicación en el inversor de frecuencia",
    "equipment.Alerta de status no inversor de frequência": "Alerta de estado en el inversor de frecuencia",
    "equipment.Alerta na corrente do magnetron": "Alerta de corriente del magnetrón",
    "equipment.Erro no modelo do equipamento": "Error en el modelo del equipo",
    "equipment.Erro no módulo de energia": "Error en el módulo de energía",
    "equipment.Erro I2C": "Error I2C",
    "equipment.Erro de temperatura alta na placa": "Error de alta temperatura en la placa",
    "equipment.Fechado": "Cerrado",
    "equipment.Aberto": "Abierto",
    "equipment.Câmara": "Cámara",
    "equipment.Placa": "Placa",
    "equipment.Tensão": "Tensión",
    "equipment.Corrente da placa": "Corriente de la placa",
    "equipment.Velocidade do motor": "Velocidad del motor",
    "equipment.Rele da resistência": "Relé de resistencia",
    "equipment.Rele de curto circuito": "Relé de cortocircuito",
    "equipment.Ventilador radial": "Ventilador radial",
    "equipment.Led vermelho": "LED rojo",
    "equipment.Led verde": "LED verde",
    "equipment.Led azul": "LED azul",
    "equipment.Erro": "Error",
    "equipment.Sensor": "Sensor",
    "equipment.Valor": "Valor",
    "equipment.Manutenção da temperatura": "Mantenimiento de la temperatura",
    "equipment.Manutenção": "Mantenimiento",
    "equipment.Esfriando": "Enfriando",
    "equipment.CEILING SENSOR ERROR": "Error del sensor de techo",
    "equipment.BALLAST SENSOR ERROR": "Error del sensor de lastre",
    "equipment.VAPORIZER SENSOR ERROR": "Error del sensor del vaporizador",
    "equipment.EQUIPMENT CONSUMPTION": "Consumo",
    "equipment.Sensores": "Sensores",
    "equipment.Falta de água": "Falta de agua",
    "equipment.Executando Receita": "Ejecutando receta",
    "equipment.Executando Limpeza": "Ejecutando limpieza",
    "equipment.Dia": "Día",
    "equipment.Semana": "Semana",
    "equipment.Mês": "Mes",
    "equipment.Tempo": "Tiempo",
    "equipment.Segunda": "Lunes",
    "equipment.Terça": "Martes",
    "equipment.Quarta": "Miércoles",
    "equipment.Quinta": "Jueves",
    "equipment.Sexta": "Viernes",
    "equipment.Sábado": "Sábado",
    "equipment.Domingo": "Domingo",
    "equipment.CONSUMO ESTIMADO": "CONSUMO ESTIMADO",
    "equipment.CONSUMO ATUAL": "CONSUMO ACTUAL",
    "equipment.ECONOMIA COM MODO ECO": "AHORRO CON MODO ECO",
    "equipment.MÉDIA SEMANAL": "PROMEDIO SEMANAL",
    "equipment.MÉDIA MENSAL": "PROMEDIO MENSUAL",
    "equipment.Consumo de energia": "Consumo de energía",
    "equipment.CONSUMO ACUMULADO": "CONSUMO ACUMULADO",
    "equipment.MÉDIA DIÁRIA": "PROMEDIO DIARIO",
    "equipment.mês selecionado": "mes seleccionado",
    "equipment.Este valor representa a soma total dos consumos de cada hora do dia.": "Este valor representa la suma total del consumo de cada hora del día.",
    "equipment.Este valor representa a soma total dos consumos de cada dia.": "Este valor representa la suma total del consumo de cada día.",
    "equipment.Este valor representa a soma total dos consumos de cada semana.": "Este valor representa la suma total del consumo de cada semana.",
    "equipment.Este valor representa a soma total dos consumos de cada mês.": "Este valor representa la suma total del consumo de cada mes.",
    "equipment.Este valor representa a média do consumo das horas, apresentando assim uma estimativa baseada em seu uso.": "Este valor representa el consumo promedio por hora, proporcionando una estimación basada en su uso.",
    "equipment.Este valor representa a média do consumo de cada dia, apresentando assim uma estimativa baseada em seu uso.": "Este valor representa el consumo promedio por día, proporcionando una estimación basada en su uso.",
    "equipment.Este valor representa a média do consumo semanal, apresentando assim uma estimativa baseada em seu uso.": "Este valor representa el consumo promedio semanal, proporcionando una estimación basada en su uso.",
    "equipment.Este valor representa a média do consumo dos últimos dois meses, apresentando assim uma estimativa baseada em seu uso.": "Este valor representa el consumo promedio de los últimos dos meses, proporcionando una estimación basada en su uso.",
    "equipment.Este valor representa a soma total da economia de consumo de cada hora do dia com a utilização do modo Eco.": "Este valor representa el ahorro total de consumo por hora utilizando el modo Eco.",
    "equipment.Este valor representa a soma total da economia de consumo de cada dia com a utilização do modo Eco.": "Este valor representa el ahorro total de consumo diario utilizando el modo Eco.",
    "equipment.Este valor representa a soma total da economia de consumo semanal com a utilização do modo Eco.": "Este valor representa el ahorro total de consumo semanal utilizando el modo Eco.",
    "equipment.Este valor representa a soma total da economia de consumo mensal com a utilização do modo Eco.": "Este valor representa el ahorro total de consumo mensual utilizando el modo Eco.",
    "equipment.Este valor representa a média de consumo dos últimos 7 dias, desconsiderando o dia atual.": "Este valor representa el consumo promedio de los últimos 7 días, excluyendo el día actual.",
    "equipment.Este valor representa a média de consumo das últimas 4 semanas.": "Este valor representa el consumo promedio de las últimas 4 semanas.",
    "equipment.Este valor representa a média de consumo dos últimos 2 meses, desconsiderando o mês atual.": "Este valor representa el consumo promedio de los últimos 2 meses, excluyendo el mes actual.",
    "equipment.Lista de consumo de energia": "Lista de consumo de energía",
    "equipment.Período": "Período",
    "equipment.Consumo (kWh)": "Consumo (kWh)",
    "equipment.Economia com ECO (kWh)": "Ahorro con ECO (kWh)",
    "equipment.Total": "Total",
    "equipment.Sensor de RI": "Sensor de RI",
    "equipment.HUMIDITY SENSOR ERROR": "Error en el sensor de humedad",
    "equipment.TEMPERATURE SENSOR ERROR": "Error en el sensor de temperatura",
    "equipment.WATER FILTER CLEANING COMPLETED": "Reemplazo del filtro de agua completado",
    "equipment.WATER FILTER CLEANING REJECTED": "Reemplazo del filtro de agua rechazado",
    "equipment.HOOD TURNED ON": "Campana encendida",
    "equipment.HOOD TURNED OFF": "Campana apagada",
    "equipment.AUTOMATIC PREHEATING REJECTED": "Precalentamiento automático rechazado",
    "equipment.média diária": "promedio diario",
    "equipment.média de execução diária": "promedio diario de ejecuciones",
    "equipment.FERMENTADORA": "FERMENTADORA",
    "equipment.FORNO": "HORNO",
    "equipment.DIA": "DÍA",
    "equipment.Baixado": "Descargado",
    "equipment.A limpeza diária do equipamento auxilia em seu bom funcionamento e impacta na garantia." : "La limpieza diaria del equipo ayuda a su buen funcionamiento y afecta la garantía.",
    "equipment.Desde a vinculação do equipamento ao IOK" : "Desde la vinculación del equipo al IOK",
    "equipment.Total desde a vinculação do equipamento ao IOK": "Total desde la vinculación del equipo al IOK",
    "equipment.Receitas do forno" : "Recetas del horno",
    "equipment.Receitas da fermentadora" : "Recetas de la fermentadora",
    "equipment.FERM." : "FERM.",
    "equipment.Fermentadora" : "Fermentadora",
    "equipment.Coifa" : "Campana extractora",
    "equipment.Preaquecimento automático" : "Precalentamiento automático",
    "equipment.nivel" : "nivel",
    "equipment.Fermentadora ligada" : "Fermentadora encendida",
    "equipment.Fermentadora desligada" : "Fermentadora apagada",
    "equipment.Forno desligado" : "Horno apagado",
    "equipment.Equipamento ligado" : "Equipo encendido",
    "equipment.Equipamento desligado" : "Equipo apagado",
    "equipment.visualizar haccp": "Ver HACCP",
    "equipment.HACCP": "HACCP",
    "equipment.Atualizar Equip.": "Actualizar equipo",
    "equipment.Consumo de agua por receita": "Consumo de agua por receta",
    "equipment.Consumo de energia por receita": "Consumo de energía por receta",
    "equipment.AINDA NAO HA DADOS DE CONSUMO DE AGUA POR RECEITA :(": "AÚN NO HAY DATOS DE CONSUMO DE AGUA POR RECETA :(",
    "equipment.AINDA NAO HA DADOS DE CONSUMO DE ENERGIA POR RECEITA :(": "AÚN NO HAY DATOS DE CONSUMO DE ENERGÍA POR RECETA :(",
    "equipment.LITROS CONSUMIDOS NO DIA": "LITROS CONSUMIDOS EN EL DÍA",
    "equipment.ENERGIA CONSUMIDA NO DIA": "ENERGÍA CONSUMIDA EN EL DÍA",
    "equipment.CONSUMO ACUMULADO SEMANAL": "CONSUMO ACUMULADO SEMANAL",
    "equipment.CONSUMO ACUMULADO MENSAL": "CONSUMO ACUMULADO MENSUAL",
    "equipment.Receitas": "Recetas",
    "equipment.Consumo (L)": "Consumo (L)",
    "equipment.Exec. dia - (L)": "Preparaciones/día - (L)",
    "equipment.Exec. semana - (L)": "Preparaciones/semana - (L)",
    "equipment.Exec. mês - (L)": "Preparaciones/mes - (L)",
    "equipment.Exec. dia - (kWh)": "Preparaciones/día - (kWh)",
    "equipment.Exec. semana - (kWh)": "Preparaciones/semana - (kWh)",
    "equipment.Exec. mês - (kWh)": "Preparaciones/mes - (kWh)",
    "equipment.Agua consumida (litros)": "Agua consumida (litros)",
    "equipment.Energia consumida (kWh)": "Energía consumida (kWh)",
    "equipment.temperatura da câmara" : "Temperatura de la cámara",
    "equipment.temperatura do vapor" : "Temperatura del vapor",
    "equipment.último evento listado" : "Último evento listado",
    "equipment.temperatura da sonda" : "Temperatura de la sonda",
    "equipment.porta" : "Puerta",
    "equipment.temperatura" : "Temperatura",
    "equipment.temperatura atual" : "Temperatura actual",
    "equipment.média de oscilação diária" : "Promedio de oscilación diaria",
    "equipment.oscilação diária da temperatura" : "Oscilación diaria de la temperatura",
    "equipment.cleaningType.smart": "Limpieza inteligente",
    "equipment.cleaningType.light": "Limpieza ligera",
    "equipment.cleaningType.medium": "Limpieza media",
    "equipment.cleaningType.heavy": "Limpieza pesada",
    "equipment.cleaningType.decalcifying": "Limpieza descalcificante",
    "equipment.cleaningType.security": "Limpieza de seguridad",
    "equipment.cleaningType.rinse": "Enjuague",
    "equipment.cleaningType.custom": "Limpieza personalizada",
    "equipment.cleaningTypeShort.smart": "Inteligente",
    "equipment.cleaningTypeShort.light": "Ligera",
    "equipment.cleaningTypeShort.medium": "Media",
    "equipment.cleaningTypeShort.heavy": "Pesada",
    "equipment.cleaningTypeShort.decalcifying": "Descalcificación",
    "equipment.cleaningTypeShort.security": "Seguridad",
    "equipment.cleaningTypeShort.rinse": "Enjuague",
    "equipment.cleaningTypeShort.custom": "Personalizada",
    "equipment.temperature.sectionTitle": "Temperatura",
    "equipment.temperature.currentChamber": "TEMPERATURA ACTUAL DE LA CÁMARA:",
    "equipment.temperature.currentProbe": "TEMPERATURA ACTUAL DE LA SONDA:",
    "equipment.temperature.currentSteam": "TEMPERATURA ACTUAL DEL VAPOR:",
    "equipment.temperature.dailyOscillation": "Oscilación diaria de la temperatura",
    "equipment.temperature.chamberShort": "Cámara",
    "equipment.temperature.probeShort": "Sonda",
    "equipment.temperature.axisLabel": "Temperatura {unit}",
    "equipment.temperature.dailyAverage": "PROMEDIO DIARIO",
    "equipment.temperature.weeklyAverage": "PROMEDIO SEMANAL",
    "equipment.temperature.monthlyAverage": "PROMEDIO MENSUAL",
    "equipment.temperature.lastListedEvent": "Último evento listado",
    "equipment.temperature.door": "Puerta",
    "equipment.temperature.open": "ABIERTA",
    "equipment.temperature.closed": "CERRADA",
    "equipment.temperature.defineTimeRange": "Definir intervalo de tiempo:",
    "equipment.temperature.until": "hasta",
    "equipment.gerar gráficos" : "generar gráficos",
    "equipment.Realizada": "Realiz.",
    "equipment.Recomendada": "Recom.",
    "equipment.Dias da semana" : "Días de la semana",
    "equipment.Horário 24h" : "Formato de 24 horas",
    "equipment.seg" : "Lun",
    "equipment.ter" : "Mar",
    "equipment.qua" : "Mié",
    "equipment.qui" : "Jue",
    "equipment.sex" : "Vie",
    "equipment.sab" : "Sáb",
    "equipment.dom" : "Dom",
    "equipment.Desconhecido" : "Desconocido",
    "equipment.AINDA NÃO HÁ DADOS DE CONSUMO DE ENERGIA AQUI :(" : "AÚN NO HAY DATOS DE CONSUMO DE ENERGÍA AQUÍ :(",
    "equipment.monthShort.Jan": "Ene",
    "equipment.monthShort.Fev": "Feb",
    "equipment.monthShort.Mar": "Mar",
    "equipment.monthShort.Abr": "Abr",
    "equipment.monthShort.Mai": "May",
    "equipment.monthShort.Jun": "Jun",
    "equipment.monthShort.Jul": "Jul",
    "equipment.monthShort.Ago": "Ago",
    "equipment.monthShort.Set": "Sep",
    "equipment.monthShort.Out": "Oct",
    "equipment.monthShort.Nov": "Nov",
    "equipment.monthShort.Dez": "Dic",
    "equipment.settingsChange.category": "Cambio de parámetros",
    "equipment.settingsChange.factoryTitle": "Cambio en parámetro técnico",
    "equipment.settingsChange.userTitle": "Cambio en parámetro de usuario",
    "equipment.settingsChange.changedTo": "{label} cambiado a {value}",
    "equipment.settingsChange.hardResetExecuted": "Hard reset ejecutado",
    "equipment.settingsChange.userFactoryResetExecuted": "Restauración de fábrica del usuario ejecutada",
    "equipment.settingsChange.magSensorEnabled": "sensor de magnetrón",
    "equipment.settingsChange.serialNumber": "número de serie",
    "equipment.settingsChange.manufactureDate": "fecha de fabricación",
    "equipment.settingsChange.inverterType": "tipo de inversor",
    "equipment.settingsChange.preHeatMotorSpeed": "velocidad del motor de precalentamiento",
    "equipment.settingsChange.voltage": "voltaje",
    "equipment.settingsChange.oemModeEnabled": "modo OEM",
    "equipment.settingsChange.controlDoor": "control de puerta",
    "equipment.settingsChange.hardReset": "hard reset",
    "equipment.settingsChange.preHeatTemperatureOne": "temperatura de precalentamiento 1",
    "equipment.settingsChange.preHeatTemperatureTwo": "temperatura de precalentamiento 2",
    "equipment.settingsChange.preHeatTime": "tiempo de precalentamiento",
    "equipment.settingsChange.preHeatTwoEnabled": "precalentamiento 2",
    "equipment.settingsChange.userFactoryReset": "restablecimiento de fábrica del usuario",
    "equipment.settingsChange.enableManualMode": "modo manual",
    "equipment.settingsChange.enableFavorites": "favoritos",
    "equipment.settingsChange.enableHeatBrown": "calentar/dorar más",
    "equipment.settingsChange.enableRepeatRecipe": "repetir receta",
    "equipment.settingsChange.enableOperatorMode": "modo operador",
    "equipment.settingsChange.enableAutoImport": "importación automática",
    "equipment.settingsChange.enableRecipePreRunMessage": "mensaje previo a la preparación de la receta",
    "equipment.settingsChange.controlDoorTwoInputs": "2 entradas",
    "equipment.settingsChange.controlDoorThreeInputs": "3 entradas",
    
    //LOJAS
    "store.Procurar loja": "Buscar tienda",
    "store.Excluir": "Eliminar",
    "store.Editar": "Editar",
    "store.nome": "Nombre",
    "store.equipamentos": "Equipo",
    "store.Equipamentos vinculados": "Equipos vinculados",
    "store.cidade": "Ciudad",
    "store.estado": "Estado",
    "store.salvar": "Guardar",
    "store.cadastrar loja": "registrar tienda",
    "store.Nome fantasia": "Nombre fantástico",
    "store.Preencha o nome da loja": "Completa el nombre de la tienda",
    "store.CNPJ": "CNPJ",
    "store.Preencha o CNPJ da loja": "Completa el CNPJ de la tienda",
    "store.CEP": "Código postal",
    "store.Preencha o CEP da loja": "Completa el código postal de la tienda",
    "store.Informe o nome fantasia": "Completa el nombre fantástico",
    "store.Cidade": "Ciudad",
    "store.Informe a cidade": "Ingresa la ciudad",
    "store.Preencha a cidade": "Completa la ciudad",
    "store.UF": "Estado",
    "store.Preencha o UF da loja": "Completa el estado de la tienda",
    "store.Bairro": "Barrio",
    "store.Informe o bairro": "Ingresa el barrio",
    "store.Preencha o bairro da loja": "Completa el barrio de la tienda",
    "store.Endereço": "Dirección",
    "store.Informe o endereço": "Ingresa la dirección",
    "store.Preencha o endereço da loja": "Completa la dirección de la tienda",
    "store.Nº": "Nro.",
    "store.Loja cadastrada com sucesso": "Tienda registrada exitosamente",
    "store.Erro ao adicionar loja. Tente novamente": "Error al agregar la tienda. Inténtalo de nuevo",
    "store.Loja deletada com sucesso": "Tienda eliminada exitosamente",
    "store.Erro ao deletar loja. Tente novamente mais tarde": "Error al eliminar la tienda. Inténtalo de nuevo más tarde",
    "store.AINDA NÃO HÁ NENHUMA LOJA CADASTRADA :(": "TODAVÍA NO HAY TIENDAS REGISTRADAS :(",
    "store.EXCLUIR LOJA": "ELIMINAR TIENDA",
    "store.Você deseja excluir a loja da plataforma IOK?": "¿Deseas eliminar la tienda de la plataforma IOK?",
    "store.Ao fazer isso, os equipamentos atrelados à ela não terão vínculo com nenhuma loja, a menos que os vincule novamente.": "Al hacerlo, el equipo vinculado a ella no estará vinculado a ninguna tienda, a menos que los vuelvas a vincular.",
    "store.loja editada com sucesso": "Tienda editada exitosamente",
    "store.não foi possível editar a loja. Tente novamente mais tarde": "No fue posible editar la tienda. Inténtalo de nuevo más tarde",
    "store.editar loja": "editar tienda",
    "store.Procurar grupo de equipamentos": "Buscar grupo de equipos",
    "store.cadastrar grupo": "grupo de registro",
    "store.AINDA NÃO HÁ NENHUM GRUPO CADASTRADO :(": "AÚN NO HAY GRUPO REGISTRADO :(",
    "store.description.AINDA NÃO HÁ NENHUM GRUPO CADASTRADO :(": "Haga clic en el botón ubicado en la esquina superior derecha y agregue grupos.",
    "store.cadastrar grupo de equipamentos": "registrar grupo de equipos",
    "store.grupo de equipamentos cadastrado com sucesso!": "!Grupo de equipos registrado exitosamente!",
    "store.não foi possível cadastrar o grupo. Tente novamente mais tarde": "No se puede registrar el grupo. Vuelve a intentarlo más tarde",
    "store.Nome do grupo": "Nombre del grupo",
    "store.informe o nome do grupo": "Introduzca el nombre del grupo",
    "store.preencha o nome do grupo": "Complete el nombre del grupo",
    "store.Grupo de equipamentos deletado com sucesso!": "Grupo de equipos eliminado exitosamente!",
    "store.Erro ao deletar o grupo. Tente novamente mais tarde": "Error al eliminar el grupo. Vuelve a intentarlo más tarde",
    "store.EXCLUIR GRUPO DE EQUIPAMENTOS": "ELIMINAR GRUPO DE EQUIPOS",
    "store.Você deseja excluir este grupo de equipamentos da plataforma IOK?": "¿Quiere eliminar este grupo de equipos de la plataforma IOK?",
    "store.Ao fazer isso, os equipamentos atrelados à ele não terão vínculo com nenhum grupo, a menos que os vincule novamente.": "Al hacer esto, los equipos vinculados a él no quedarán vinculados a ningún grupo, a menos que los vuelvas a vincular.",
    "store.grupo de equipamentos editado com sucesso!": "Grupo de equipos editado exitosamente!",
    "store.não foi possível editar o grupo. Tente novamente mais tarde": "No se puede editar el grupo. Vuelve a intentarlo más tarde",
    "store.editar grupo de equipamentos": "editar grupo de equipos",
    "store.CEP não encontrado no Brasil": "Código postal no encontrado en Brasil",
    "store.Cadastrar": "Registrar",
    "store.Equipamentos vinculados": "Equipos vinculados",
    
    //NAVBAR
    "navbar.home": "home",
    "navbar.cookbook": "cookbook",
    "navbar.my menus": "mis menús",
    "navbar.equipment": "equipamiento",
    "navbar.users": "usuarios",
    "navbar.calls": "servicios",
    "navbar.settings": "configuraciones",
    "navbar.help": "ayuda",
    "navbar.logout": "Cerrar sesión",
    "navbar.Editar conta": "Editar cuenta",
    "navbar.API Externa": "API Externa",
    "navbar.companhias": "Empresas",
    "navbar.information": "Información de IOK",
    
    //FOOTERBAR
    "footerBar.menu": "Menú",
    "footerBar.cookbook": "Cookbook",
    "footerBar.home": "Inicio",
    "footerBar.menus": "Menús",
    "footerBar.notifications": "Notificaciones",
    
    //ATENDIMENTOS 
    "calls.ATENDIMENTOS EM ABERTO": "SERVICIOS EN CURSO",
    "calls.ATENDIMENTOS ENCERRADOS": "SERVICIOS CERRADOS",
    
    //MAP
    "map.título": "Ubicación",
    "map.erro": "Error",
    "map.mensagem de erro": "No se puede cargar el mapa",
    "map.Localização não disponível": "Ubicación no disponible",
    
    //MODAL
    "modal.CONFIRMAR": "CONFIRMAR",
    "modal.Salvar alterações": "Guardar ediciones",
    "Modal.Há alterações não salvas nos parâmetros dos passos": "Hay cambios no guardados en los parámetros del paso",
    "Modal.Como deseja proceder?": "¿Cómo deseas proceder?",
    "Modal.Avaliar alterações realizadas": "Evaluar cambios realizados",
    "Modal.Descartar alterações": "Descartar cambios",
    
    //USUÁRIOS
    "user.Nome": "Nombre",
    "user.E-mail": "Correo electrónico",
    "user.Permissão": "Permiso",
    "user.Loja": "Tienda",
    "user.Status": "Estado",
    "user.Excluir": "Eliminar",
    "user.Editar": "Editar",
    "user.Procurar usuário": "Buscar usuario",
    "user.ADICIONAR USUÁRIO": "AGREGAR USUARIO",
    "user.AINDA NÃO HÁ NENHUM USUÁRIO CADASTRADO :(": "AÚN NO HAY USUARIOS REGISTRADOS :(",
    "user.+ Usuário": "+ Usuario",
    "user.Informe o nome do usuário": "Ingresa el nombre de usuario",
    "user.Preencha o nome do usuário": "Completa el nombre de usuario",
    "user.Informe o e-mail do usuário": "Ingresa el correo electrónico del usuario",
    "user.Preencha com um e-mail válido": "Ingresa una dirección de correo electrónico válida",
    "user.Administrador": "Administrador",
    "user.Usuário": "Usuario",
    "user.Preencha o telefone do usuário": "Completa el número de teléfono del usuario",
    "user.Selecione a permissão do usuário": "Selecciona el permiso del usuario",
    "user.Ativo": "Activo",
    "user.Inativo": "Inactivo",
    "user.Usuário deletado da plataforma com sucesso!": "Usuario eliminado de la plataforma exitosamente!",
    "user.Ocorreu um erro. Tente novamente mais tarde": "Ha ocurrido un error. Inténtalo de nuevo más tarde.",
    "user.EXCLUIR USUÁRIO": "ELIMINAR USUARIO",
    "user.delete.paragrafo 1": "¿Deseas eliminar al usuario de la plataforma IOK?",
    "user.delete.paragrafo 2": "Al hacerlo, perderá el acceso a todas las herramientas de la plataforma, a menos que se le vuelva a agregar siguiendo las instrucciones de registro.",
    "user.EDITAR USUÁRIO": "EDITAR USUARIO",
    "user.Usuário editado com sucesso!": "Usuario editado exitosamente!",
    "user.Não foi possível editar este usuário. Por favor, tente mais tarde": "No fue posible editar a este usuario. Por favor, inténtalo más tarde.",
    "user.INFORMAÇÕES DO USUÁRIO": "INFORMACIÓN DEL USUARIO",
    "user.Telefone": "Teléfono",
    "user.Não foi possível cadastrar este usuário. Por favor, tente mais tarde": "No fue posible registrar a este usuario. Por favor, inténtalo más tarde.",
    "user.Usuário adicionado com sucesso!": "!Usuario agregado exitosamente!",
    "user.CRIAR TIPO DE USUÁRIO": "CREAR TIPO DE USUARIO",
    "user.Criar novo tipo de usuário": "Crear nuevo tipo de usuario",
    "user.Adicionar novo usuário": "Agregar nuevo usuario",
    "user.Permissões": "Permisos",
    "user.Preencha o nome do novo tipo de usuário": "Completa el nombre del nuevo tipo de usuario",
    "user.Selecione pelo menos uma permissão": "Selecciona al menos un permiso",
    "user.Não foi possível carregar as permissões": "No fue posible cargar los permisos",
    "user.Tipo de usuário criado com sucesso!": "!Tipo de usuario creado exitosamente!",
    "user.Não foi possível criar este novo tipo de usuário. Por favor, tente mais tarde": "No fue posible crear este nuevo tipo de usuario. Por favor, inténtalo más tarde.",
    "user.Não foi possível carregar os tipos de usuário da companhia": "No fue posible cargar los tipos de usuario de la empresa",
    "user.Tipo de usuário": "Tipo de usuario",
    "user.E-mail já cadastrado na plataforma. Informe um novo e-mail": "Correo electrónico ya registrado en la plataforma. Ingresa un nuevo correo electrónico.",
    "user.UNIR CONTAS": "UNIR CUENTAS",
    "user.ID da companhia": "ID de la compañía",
    "user.Digite o ID da companhia que deseja unir a sua conta": "Ingrese el ID de la empresa con la que desea fusionar su cuenta",
    "user.Preencha o ID da companhia": "Complete el ID de la empresa",
    "user.O administrador da conta com a qual deseja se unir poderá localizar o ID ao clicar em seu nome de usuário, localizado no menu superior, no canto direito da tela.":
    "El administrador de la cuenta a la que desea unirse podrá encontrar el ID haciendo clic en su nombre de usuario, ubicado en el menú superior, en la esquina derecha de la pantalla.",
    "user.O administrador da outra conta receberá um e-mail para aceitar sua solicitação. Assim que for aceita, a união das duas contas será realizada!":
    "El administrador de la otra cuenta recibirá un correo electrónico para aceptar su solicitud. Una vez aceptada, las dos cuentas se fusionarán!",
    "user.Não foi possível solicitar a união de contas. Por favor, confirme o ID ou tente mais tarde": "No se puede solicitar la fusión de cuentas. Confirma tu ID o inténtalo más tarde.",
    "user.SOLICITAÇÃO APROVADA COM SUCESSO": "SOLICITUD APROBADA EXITOSAMENTE",
    "user.AGUARDE ENQUANTO REALIZAMOS A UNIÃO DAS CONTAS. ESTE PROCESSO PODE LEVAR ALGUNS MINUTOS...": "POR FAVOR ESPERE MIENTRAS CONECTAMOS LAS CUENTAS. ESTE PROCESO PUEDE TARDAR UNOS MINUTOS...",
    "user.UNIÃO DE CONTAS FINALIZADA COM SUCESSO! CLIQUE NO BOTÃO ABAIXO PARA ACESSAR A PLATAFORMA.": "¡UNIÓN DE CUENTAS COMPLETADA CON ÉXITO! HAZ CLIC EN EL BOTÓN DE ABAJO PARA ACCEDER A LA PLATAFORMA.",
    "user.NÃO CONSEGUIMOS REALIZAR A UNIÃO DAS CONTAS. POR FAVOR, TENTE NOVAMENTE. SE O PROBLEMA PERSISTIR, ENTRE EM CONTATO COM NOSSO SUPORTE.":
    "NO PODEMOS FUSIONAR LAS CUENTAS. INTÉNTALO DE NUEVO. SI EL PROBLEMA PERSISTE, CONTACTE CON NUESTRO SOPORTE.",
    "user.possui todos os acessos": "tiene todo el acceso",
    "user.possui o acesso das abas cookbook, meus menus e equipamentos": "tiene acceso al libro de cocina, a mis menús y a las pestañas de equipo",
    "user.possui apenas o acesso da aba cookbook": "solo tiene acceso a la pestaña del libro de cocina",
    "user.possui apenas o acesso da aba equipamentos": "solo tiene acceso a la pestaña de equipo",
    "user.possui apenas o acesso da aba meus menus": "solo tiene acceso a la pestaña mis menús",
    "user.Grupo de equipamentos": "Grupo de equipos",
    "user.Informe o telefone do usuário": "Ingrese el número de teléfono del usuario",
    "user.Nenhum grupo criado": "No se crearon grupos",
    "user.Digite o ID da companhia que terá acesso à sua conta": "Ingrese el ID de la empresa que tendrá acceso a su cuenta",
    "user.Ao informar um ID para unir contas com sua companhia, esteja ciente de que o novo usuário também se tornará Administrador da conta de sua companhia. É importante informar que a partir do momento em que um usuário aceitar unir contas com sua companhia, a companhia pertencente a ele deixará de existir.":
    "Al proporcionar una identificación para fusionar cuentas con su empresa, tenga en cuenta que el nuevo usuario también se convertirá en administrador de la cuenta de su empresa. Es importante informar que desde el momento en que un usuario acepta unir cuentas a su empresa, la empresa que le pertenece dejará de existir.",
    "user.Exemplo: Sua conta: 001 | Outra conta: 111. Depois de unir contas com você, a outra conta passará a ser 001.": "Ejemplo: Tu cuenta: 001 | Otra cuenta: 111. Después de fusionar cuentas con usted, la otra cuenta pasará a ser 001.",
    "user.O administrador da outra conta poderá localizar o ID ao clicar em seu nome de usuário, localizado no menu superior, no canto direito da tela.": "El administrador de la otra cuenta podrá localizar el ID haciendo clic en su nombre de usuario, ubicado en el menú superior, en la esquina derecha de la pantalla.",
    "user.Tela de Equipamentos": "Pantalla de Equipos",
    "user.Tela de Meus Menus": "Pantalla de Mis Menús",
    "user.Tela do Cookbook": "Pantalla del Cookbook",
    "user.Tela de Usuários": "Pantalla de Usuarios",
    "user.Aba de Suporte": "Pestaña de Soporte",
    "user.Usuário Comum": "Usuario Común",
    "user.Usuário do Cookbook": "Usuario del Cookbook",
    "user.Usuário de Equipamentos": "Usuario de Equipos",
    "user.Usuário de Meus Menus": "Usuario de Mis Menús",
    "user.Você deseja excluir seu acesso da plataforma IOK?": "¿Deseas eliminar tu acceso a la plataforma IOK?",
    "user.Ao fazer isso, você perderá o acesso a todas as ferramentas da plataforma e, para voltar a acessá-la, será necessário ser adicionado à ela novamente.": "Al hacer esto, perderás el acceso a todas las herramientas de la plataforma y, para volver a acceder, tendrás que ser añadido a ella nuevamente.",
    "user.CONFIRMAÇÃO": "CONFIRMACIÓN",
    "user.Confirme sua senha": "Confirma tu contraseña",
    "user.Senha incorreta": "Contraseña incorrecta",
    "menus.Os equipamentos e menus criados por ele serão transferidos para o seu nome": "Los equipos y menús creados por él serán transferidos a su nombre.",
    
    //TUTORIAIS
    "tutorial.Fechar": "Cerrar",
    "tutorial.Fim": "Finalizar",
    "tutorial.Próximo": "Siguiente",
    "tutorial.Abrir": "Abrir",
    "tutorial.Pular tutorial": "Omitir tutorial",
    "tutorial.Editar detalhes da receita": "Editar detalles de la receta",
    "tutorial.Agora você pode adicionar mais detalhes às suas receitas e deixá-las ainda mais completas. Clique em Editar detalhes e preencha as informações necessárias.": "Ahora puedes agregar más detalles a tus recetas y hacerlas aún más completas. Haz clic en Editar detalles y completa la información necesaria.",
    "tutorial.Salvar edição da receita": "Guardar edición de receta",
    "tutorial.Depois de informar mais detalhes da receita, clique em Salvar.": "Después de haber proporcionado más detalles de la receta, haz clic en Guardar",
    "tutorial.Editar registro de um equipamento": "Editar registro del equipo",
    "tutorial.Para completar o registro de seus equipamentos, abra o menu lateral, clique em Editar e preencha as informações de Categoria e Loja.": "Para completar el registro de tu equipo, abre el menú lateral, haz clic en Editar y completa la información de la Categoría y la Tienda.",
    "tutorial.Editar usuário": "Editar usuario",
    "tutorial.Para completar o cadastro dos usuários, abra o menu lateral, clique em Editar e preencha a informação referente a Loja a qual ele faz parte.": "Para completar el registro de usuario, abre el menú lateral, haz clic en Editar y completa la información sobre la tienda a la que pertenecen.",
    "tutorial.Salvar edições de um equipamento": "Guardar las ediciones de un equipo",
    "tutorial.Depois de completar o registro de seus equipamentos, clique em Salvar.": "Después de completar el registro de tu equipo, haz clic en Guardar.",
    "tutorial.Ao clicar sobre a linha de um equipamento cadastrado em uma loja, você pode visualizar mais estatísticas e informações sobre ele, além de poder solicitar um atendimento ou disparar atualizações.": "Al hacer clic en la línea de un equipo registrado en una tienda, podrás ver más estadísticas e información sobre él, además de poder solicitar un servicio o activar actualizaciones.",
    "tutorial.Para visualizar mais informações sobre a loja, como localização e receitas mais preparadas, clique sobre a linha da unidade que deseja analisar.": "Para ver más información sobre la tienda, como la ubicación y las recetas más preparadas, haga clic en la fila de la unidad que desea analizar.",
    "tutorial.Criar receita": "Crear receta",
    "tutorial.No cookbook você pode criar suas próprias receitas! Clique em Criar Receita e preencha todas as informações necessárias.": "¡En el Cookbook puedes crear tus propias recetas! Haz clic en Crear Receta y completa toda la información necesaria.",
    "tutorial.Editar ou excluir um usuário": "Editar o eliminar un usuario",
    "tutorial.Para excluir ou editar as informações de um usuário já cadastrado, clique no menu lateral e selecione a opção desejada.": "Para eliminar o editar la información de un usuario registrado, haz clic en el menú lateral y selecciona la opción deseada.",
    "tutorial.Gerenciamento de usuários": "Gestión de usuarios",
    "tutorial.Aqui você pode gerenciar seus usuários com mais facilidade. Ao clicar em + Usuário, você poderá adicionar um novo usuário ou criar um novo tipo de usuário.": "Aquí podrás gestionar tus usuarios más fácilmente. Al hacer clic en + Usuario, puede agregar un nuevo usuario o crear un nuevo tipo de usuario.",
    "tutorial.Suas receitas": "Tus recetas",
    "tutorial.Pelo cookbook você também encontra suas próprias receitas, além de poder criá-las! Clique em Receitas Salvas para visualizar as receitas que foram salvas do cookbook da Prática e também as criadas por você.": "A través del Cookbook, también puedes encontrar tus propias recetas, ¡además de poder crearlas! Haz clic en Recetas Guardadas para ver las recetas guardadas del Cookbook de Prática y las creadas por ti.",
    "tutorial.Filtros do Cookbook": "Filtros del Cookbook",
    "tutorial.Para facilitar a navegação pelas receitas, você pode aplicar filtros a elas. Basta clicar no filtro desejado e escolher uma de suas opções.": "Para facilitar la navegación a través de las recetas, puedes aplicar filtros a ellas. Solo tienes que hacer clic en el filtro deseado y elegir una de sus opciones.",
    "tutorial.Cookbook": "Cookbook",
    "tutorial.No cookbook, em Receitas Disponíveis, você encontrará as receitas criadas pelos Chefs da Prática e poderá utilizá-las sempre que quiser.": "En el Cookbook, en Recetas Disponibles, encontrarás las recetas creadas por los chefs de Prática y podrás utilizarlas cuando lo desees.",
    "tutorial.Atualizar equipamentos": "Actualizar equipo",
    "tutorial.Para enviar uma atualização a seus equipamentos, clique em Atualizar Equipamentos, selecione os modelos que deseja atualizar e a forma como deseja realizar essa atualização - via wi-fi ou pen drive. Depois disso, clique em Confirmar.": "Para enviar una actualización a tu equipo, haz clic en Actualizar Equipo, selecciona los modelos que deseas actualizar y cómo deseas hacerlo, ya sea mediante Wi-Fi o una unidad flash USB. Después de eso, haz clic en Confirmar.",
    "tutorial.Adicionar equipamento": "Agregar equipo",
    "tutorial.Para adicionar um equipamento à sua conta, clique em Adicionar Equipamento e preencha as informações do modal. Depois disso, clique em Salvar.": "Para agregar un equipo a tu cuenta, haz clic en Agregar Equipo y completa la información del modal. Después, haz clic en Guardar.",
    "tutorial.Editar equipamento": "Editar equipo",
    "tutorial.Para desvincular um equipamento ou editar suas informações, clique no menu lateral e selecione a opção desejada.": "Para desvincular un equipo o editar su información, haz clic en el menú lateral y selecciona la opción deseada.",
    "tutorial.Seus equipamentos": "Tus equipos",
    "tutorial.Aqui você visualizará todos os equipamentos cadastrados em sua plataforma.": "Aquí verás todos los equipos registrados en tu plataforma.",
    "tutorial.Restaurar arquivos": "Restaurar archivos",
    "tutorial.Para restaurar um arquivo excluído ou deletá-lo permanentemente, clique no menu lateral e selecione a opção desejada.": "Para restaurar un archivo eliminado o eliminarlo permanentemente, haz clic en el menú lateral y selecciona la opción deseada.",
    "tutorial.Lixeira": "Papelera",
    "tutorial.Os menus excluídos serão mantidos na Lixeira por 30 dias. Depois desse prazo serão excluídos permanentemente.": "Los menús eliminados se mantendrán en la Papelera durante 30 días. Después de este período, se eliminarán permanentemente.",
    "tutorial.Salvar edições de usuário": "Guardar ediciones de usuario",
    "tutorial.Depois de completar o cadastro dos usuários, clique em Salvar.": "Después de completar el registro del usuario, haz clic en Guardar.",
    "tutorial.Criar menu": "Crear menú",
    "tutorial.Para criar e personalizar um menu, clique em Criar Menu e preencha as informações necessárias no modal. Você pode editar um menu a qualquer momento.": "Para crear y personalizar un menú, haz clic en Crear Menú y completa la información necesaria en el modal. Puedes editar un menú en cualquier momento.",
    "tutorial.Importar menu": "Importar menú",
    "tutorial.Para importar um menu, clique em Importar Menu e selecione o modelo e versão do equipamento.": "Para importar un menú, haz clic en Importar Menú y selecciona el modelo y la versión del equipo.",
    "tutorial.Criar grupo": "Crear grupo",
    "tutorial.Para organizar suas receitas em grupos, clique em Criar Grupo e preencha as informações necessárias no modal.": "Para gestionar tus recetas de grupo, haz clic en Crear Grupo y completa la información necesaria en el modal.",
    "tutorial.Tipos de usuário": "Tipos de usuarios",
    "tutorial.Agora você também pode criar tipos de usuários com permissões específicas para atender melhor a sua organização.": "Ahora también puede crear tipos de usuarios con permisos específicos para servir mejor a su organización.",
    "tutorial.Gerenciamento de contas": "Administración de cuentas",
    "tutorial.Se caso outra pessoa da sua organização também migrou a conta principal da empresa, aqui você pode unir as duas contas.": "Si alguien más en su organización también migró su cuenta principal de empresa, aquí puede fusionar las dos cuentas.",
    "tutorial.Para completar o registro de seus equipamentos, abra o menu lateral, clique em Editar e preencha as informações de Grupo.": "Para completar el registro de su equipo, abra el menú lateral, haga clic en Editar y complete la información del Grupo.",
    "tutorial.Para completar o cadastro dos usuários, abra o menu lateral, clique em Editar e preencha a informação referente ao Grupo de equipamentos a qual ele faz parte.": "Para completar el registro de usuario, abra el menú lateral, haga clic en Editar y complete la información relativa al Grupo de Equipo al que pertenece.",
    "tutorial.Grupos de equipamentos": "Grupos de equipos",
    "tutorial.Na aba Grupos você pode visualizar os grupos cadastrados e os equipamentos distribuídos entre eles. Além disso, é possível cadastrar novos grupos e editar os já cadastrados.": "En la pestaña Grupos podrás visualizar los grupos registrados y los equipos distribuidos entre ellos. Además, es posible registrar nuevos grupos y editar los ya registrados.",
    "tutorial.Detalhes de grupos": "Detalles del grupo",
    "tutorial.Para visualizar mais informações sobre o grupo, como localização e receitas mais preparadas, clique sobre a linha que deseja analisar.": "Para visualizar más información sobre el grupo, como la ubicación y las recetas más preparadas, haz clic sobre la fila que deseas analizar.",
    "tutorial.Equipamentos em grupos": "Equipo en grupos",
    "tutorial.Ao clicar sobre a linha de um equipamento cadastrado em um grupo, você pode visualizar mais estatísticas e informações sobre ele, além de poder solicitar um atendimento ou disparar atualizações.": "Al hacer clic en la línea de un dispositivo registrado en un grupo, podrás ver más estadísticas e información sobre el mismo, además de poder solicitar servicio o activar actualizaciones.",
    "tutorial.Grupos": "Grupos",
    "tutorial.Atualização e cache": "Actualización y caché",
    "tutorial.Para atualizar a plataforma e corrigir eventuais problemas de cache, clique aqui.": "Para actualizar la plataforma y corregir cualquier problema de caché, haga clic aquí.",
    "tutorial.Dados dos equipamentos": "Datos de los equipos",
    "tutorial.Ao clicar sobre a linha de um equipamento, você pode visualizar mais estatísticas e informações sobre ele, como as receitas mais preparadas, limpezas realizadas e outros dados relevantes.": "Al hacer clic sobre la fila de un equipo, puedes visualizar más estadísticas e información sobre él, como las recetas más preparadas, limpiezas realizadas y otros datos relevantes.",
    "tutorial.Para alterar o idioma de sua plataforma, clique em Idioma e selecione a linguagem desejada.": "Para cambiar el idioma de su plataforma, haga clic en Idioma y seleccione el idioma deseado.",
    "tutorial.Alterar idioma": "Cambia el idioma",
    "tutorial.Para editar ou configurar sua conta, clique em seu nome e selecione a opção desejada.": "Para editar o configurar su cuenta, haga clic en su nombre y seleccione la opción deseada.",
    "tutorial.Editar conta": "Editar cuenta",
    "tutorial.Total de Usuários Cadastrados em sua conta.": "Total de usuarios registrados en su cuenta.",
    "tutorial.Home": "Home",
    "tutorial.Localização de seus equipamentos, sendo possível expandir o mapa para melhor visualização;": "Ubicación de su equipo, permitiendo ampliar el mapa para una mejor visualización;",
    "tutorial.Atualizações referentes a versão dos equipamentos vinculados a sua conta;": "Actualizaciones sobre la versión del equipo vinculado a su cuenta;",
    "tutorial.Total de Receitas Cadastradas;": "Ingresos Totales Registrados;",
    "tutorial.Menus Disponíveis;": "Menús disponibles;",
    "tutorial.Esta é a sua home! Aqui você encontra um resumo geral sobre sua conta;" : "¡Esta es tu página de inicio! Aquí encontrarás un resumen general de tu cuenta;",
    "tutorial.Clique nas abas do menu para explorar a plataforma e conhecer tudo o que ela pode oferecer.": "Haz clic en las pestañas del menú para explorar la plataforma y descubrir todo lo que puede ofrecer.",
    "tutorial.Exportar menu": "Menú exportar",
    "tutorial.Depois de personalizar seu menu, exporte-o para seus equipamentos pela internet ou por pen drive.": "Después de personalizar su menú, expórtelo a sus dispositivos a través de Internet o mediante pendrive.",
    "tutorial.Na aba Localização você pode visualizar os endereços já cadastrados, além de criar localizações precisas para vincular seus equipamentos a elas.": "En la pestaña Ubicación podrás visualizar las direcciones ya registradas, además de crear ubicaciones precisas para vincular tu equipo a ellas.",
    "tutorial.Localização": "Ubicación",
    "tutorial.Informações sobre o equipamento": "Información del equipo",
    "tutorial.Equipamentos Ligados e quantos estão enviando dados de uso;" : "Equipos conectados y cuántos están enviando datos de uso;",
    
    //RECOVER ACCOUNT
    "recoverAccount.Para prosseguir, selecione a categoria na qual você se encaixa:": "Para continuar, selecciona la categoría a la que perteneces:",
    "recoverAccount.Deseja acessar a plataforma como DISTRIBUIDOR? Crie sua conta clicando em EMPRESA e entre em contato conosco para liberarmos os demais acessos.": "¿Deseas acceder a la plataforma como DISTRIBUIDOR? Crea tu cuenta haciendo clic en EMPRESA y contáctanos para habilitar los demás accesos.",
    "recoverAccount.A qual organização você pertence": "¿A qué organización perteneces?",
    
    //RECOVER PASSWORD
    "recoverPassword.E-mail para recuperação de senha": "Correo electrónico para recuperación de contraseña",
    "recoverPassword.Informe o e-mail cadastrado na plataforma": "Ingresa el correo electrónico registrado en la plataforma.",
    "recoverPassword.E-mail inválido. Por favor, verifique": "Correo electrónico no válido. Por favor, verifica.",
    "recoverPassword.RECUPERAR SENHA": "RECUPERAR CONTRASEÑA",
    "recoverPassword.EM BREVE VOCÊ RECEBERÁ UM E-MAIL COM O LINK DE RECUPERAÇÃO DE SENHA": "PRONTO RECIBIRÁS UN CORREO ELECTRÓNICO CON EL ENLACE DE RECUPERACIÓN DE CONTRASEÑA.",
    "recoverPassword.Login": "Inicio de sesión",
    "recoverPassword.Informe seu e-mail": "Ingresa tu correo electrónico.",
    "recoverPassword.Crie uma nova senha": "Crea una nueva contraseña",
    "recoverPassword.O campo senha deve conter no mínimo 6 caracteres": "El campo de la contraseña debe tener al menos 6 caracteres.",
    "recoverPassword.Confirme sua senha": "Confirmar contraseña",
    "recoverPassword.As senhas devem ser iguais": "Las contraseñas deben coincidir.",
    "recoverPassword.ENTRAR": "ENTRAR",
    "recoverPassword.EM BREVE VOCÊ RECEBERÁ UM E-MAIL PARA CONFIRMAR SUA IDENTIDADE": "PRONTO RECIBIRÁS UN CORREO ELECTRÓNICO PARA CONFIRMAR TU IDENTIDAD.",
    "recoverPassword.CONTINUAR": "CONTINUAR",
    "recoverPassword.CONFIRMAR": "CONFIRMAR",
    "recoverPassword.Por segurança, o acesso à conta foi bloqueado devido a tentativas de login incorretas.": "Por razones de seguridad, el acceso a la cuenta ha sido bloqueado debido a intentos de inicio de sesión incorrectos.",
    "recoverPassword.Para desbloquear sua conta, siga as instruções após clicar no botão abaixo:": "Para desbloquear su cuenta, siga las instrucciones después de hacer clic en el botón a continuación:",
    "recoverPassword.Desbloquear conta": "Desbloquear cuenta",
    "recoverPassword.Você recebeu um e-mail para iniciar o desbloqueio de sua conta.": "Ha recibido un correo electrónico para iniciar el desbloqueo de su cuenta.",
    "recoverPassword.Verifique sua caixa de entrada ou spam.": "Verifique su bandeja de entrada o carpeta de spam.",
    "recoverPassword.Verifique seu e-mail": "Verifique su correo electrónico.",
    "recoverPassword.Informe seu e-mail de login e crie uma nova senha para acessar sua conta.": "Ingrese su correo electrónico de inicio de sesión y cree una nueva contraseña para acceder a su cuenta.",
    
    // EXPORT
    "export.Limpezas": "Limpiezas",
    "export.Eventos": "Eventos",
    "export.Lista de receitas preparadas": "Lista de recetas preparadas",
    "export.Lista de limpezas realizadas": "Lista de limpiezas realizadas",
    "export.Lista de eventos ocorridos": "Lista de eventos ocurridos",
    "export.Exportar dados": "Exportar datos",
    "export.Exportar": "Exportar",
    "export.Informações do equipamento": "Información del equipo",
    "export.Dados exportados com sucesso!": "¡Datos exportados con éxito!",
    "export.Não foi possível exportar os dados. Por favor, tente novamente mais tarde.": "No se pudo exportar los datos. Por favor, inténtelo de nuevo más tarde.",
    "export.Detalhes do menu": "Detalles del menú",
    "export.Detalhes de receitas": "Detalles de recetas",
    "export.Detalhes e Passos": "Detalles y Pasos",
    "export.Exportando dados. Em breve o arquivo estará disponível!": "Exportando datos. ¡El archivo estará disponible en breve!",
    "export.Resumo dos passos": "Resumen de los pasos",
    "export.salvar imagem": "guardar imagen",
    "export.Nenhum modelo foi selecionado": "Ningún modelo fue seleccionado",
    
    // COMPANIES PAGE
    "company.Procurar companhia": "Buscar compañía",
    "company.Adicionar companhia": "Añadir compañía",
    "company.AINDA NÃO HÁ COMPANHIAS CADASTRADAS :(": "AÚN NO HAY COMPAÑÍAS REGISTRADAS :(",
    "company.description.AINDA NÃO HÁ COMPANHIAS CADASTRADAS :(": "Haga clic en el botón ubicado en la esquina superior derecha y agregue compañías.",
    "company.Adicionar": "Añadir",
    "company.ADICIONAR EQUIPAMENTOS": "AÑADIR EQUIPOS",
    "company.Preencha pelo menos um número de série": "Ingrese al menos un número de serie",
    "company.Informe os números de série": "Ingrese los números de serie",
    "company.Número de série": "Número de serie",
    "company.Para incluir vários equipamentos, separe-os com ponto e vírgula (;).": "Para incluir varios equipos, sepárelos con un punto y coma (;).",
    "company.Informe o número de série do equipamento que deseja adicionar abaixo.": "Ingrese el número de serie del equipo que desea añadir a continuación.",
    "company.Números de série adicionados com sucesso!": "¡Números de serie añadidos con éxito!",
    "company.Não foi possível adicionar os números de série. Tente novamente mais tarde": "No se pudieron añadir los números de serie. Inténtelo de nuevo más tarde.",
    "company.adicionar": "añadir",
    "company.Procurar por companhia ou ID": "Buscar por compañía o ID",
    "company.Companhia": "Compañía",
    "company.E-mail principal": "Correo electrónico principal",
    "company.Local": "Ubicación",
    "company.Companhia adicionada com sucesso!": "¡Compañía añadida con éxito!",
    "company.Não foi possível cadastrar a companhia": "No fue posible registrar la compañía",
    "company.REMOVER COMPANHIA": "ELIMINAR COMPAÑÍA",
    "company.Você deseja remover a companhia definitivamente? Os equipamentos vinculados a ela também serão removidos de sua conta.": "¿Desea eliminar la compañía permanentemente? Los equipos vinculados a ella también se eliminarán de su cuenta.",
    "company.Esta ação não poderá ser desfeita.": "Esta acción no se podrá deshacer.",
    "company.A companhia foi removida com sucesso!": "¡La compañía se eliminó con éxito!",
    "company.Não foi possível remover a companhia": "No fue posible eliminar la compañía",
    "company.Quant. de fornos": "Cant. de hornos",
    "company.Fornos conectados": "Hornos conectados",
    "company.Fornos não conectados": "Hornos no conectados",
    "company.AINDA NÃO HÁ EQUIPAMENTOS CADASTRADOS :(": "AÚN NO HAY EQUIPOS REGISTRADOS :(",
    "company.description.AINDA NÃO HÁ EQUIPAMENTOS CADASTRADOS :(": "Haga clic en el botón ubicado en la esquina superior derecha y agregue equipos.",
    "company.excluir equipamento": "Eliminar equipo",
    "company.Você deseja excluir o equipamento selecionado definitivamente?": "¿Desea eliminar definitivamente el equipo seleccionado?",
    "company.Número de série editado com sucesso!": "¡Número de serie editado con éxito!",
    "company.Não foi possível editar o número de série. Tente novamente mais tarde": "No fue posible editar el número de serie. Inténtelo de nuevo más tarde.",
    "company.Informe o número de série": "Ingrese el número de serie",
    "company.Preencha um número de série": "Complete un número de serie",
    "company.EDITAR EQUIPAMENTO": "EDITAR EQUIPO",
    "company.Modelo": "Modelo",
    "company.Cadastro": "Registro",
    "company.Conectado": "Conectado",
    "company.SELECIONE EQUIPAMENTOS PARA EXCLUIR": "SELECCIONE EQUIPOS PARA ELIMINAR",
    "company.O equipamento foi removida com sucesso!": "¡El equipo se eliminó con éxito!",
    "company.Não foi possível remover o equipamento": "No fue posible eliminar el equipo",
    "company.Caracteres especiais não são permitidos, exceto o ponto e vírgula (';')": "No se permiten caracteres especiales, excepto el punto y coma (';')",
    "company.Preencha o número de série sem caracteres especiais": "Ingrese el número de serie sin caracteres especiales",
    "company.Um ou mais números de série já estão provisionados para outra companhia": "Uno o más números de serie ya están aprovisionados para otra compañía.",
    "company.Um ou mais números de série já estão conectados na conta de outra companhia": "Uno o más números de serie ya están conectados a la cuenta de otra compañía.",
    
    // Error
    "error.Ocorreu um erro ao carregar esta seção": "Se produjo un error al cargar esta sección",
    "error.Tentar novamente": "Intentar de nuevo",
    
    //DASHBOARDS
    "dashboard.fornos vinculados" : "HORNOS VINCULADOS",
    "dashboard.ativos" : "Activos",
    "dashboard.inativos" : " Inactivos",
    "dashboard.sem status" : " Sin estado",
    "dashboard.fornos atualizados" : "HORNOS ACTUALIZADOS",
    "dashboard.com a versão do software mais recente" : "Con la versión de software más reciente",
    "dashboard.chamados" : "LLAMADAS DE SERVICIO",
    "dashboard.veja mais no app cliente" : "Ver más en la aplicación del cliente",
    "dashboard.limpeza diária" : "LIMPIEZA DIARIA",
    "dashboard.dos fornos estão em dia" : "de los hornos están al día",
    "dashboard.top 3" : "Top 3",
    "dashboard.média de execuções de receitas por hora" : "Promedio de ejecuciones de recetas por hora",
    "dashboard.avisos" : "ADVERTENCIAS",
    "dashboard.ver mais" : "Ver más",
    "dashboard.abertos pela plataforma IOK" : "Abiertos a través de la plataforma IOK",
    "dashboard.equipamentos" : "Equipos",
    "dashboard.receitas" : "Recetas",
    "dashboard.executada" : "preparada",
    "dashboard.vezes" : "veces",
    "dashboard.forno" : "Horno",
    "dashboard.média por hora" : "Promedio por hora",
    "dashboard.editar" : "editar",
    "dashboard.endereço:" : "Dirección:",
    "dashboard.cep:" : "C.P.:",
    "dashboard.estatísticas" : "Estadísticas",
    "dashboard.uso de equipamento" : "Uso del equipo",
    "dashboard.pico de uso" : "Pico de uso",
    "dashboard.receitas mais executadas por equipamento" : "Recetas más ejecutadas por equipo",
    "dashboard.recolher" : "ocultar",
    "dashboard.TOROS TC CONECTADOS:" : "TOROS TC CONECTADOS:",
    "dashboard.Consumo de energia - Lastro Toro TC" : "Consumo de energía – Lastro Toro TC",
    "dashboard.tootilp": "Es la suma de todas las recetas preparadas en el día actual, dividida por la cantidad de horas que el horno ha estado encendido.",
    "dashboard.noResults": "No se encontraron resultados :(",
    "dashboard.Preaquecimento": "Precalentamiento",
    "dashboard.Esfriamento": "Enfriamiento",
    "dashboard.Execução de receitas": "Preparación de recetas",
    "dashboard.Execução de receitas TSi": "Preparación de recetas TSi",
    "dashboard.Modo manual": "Modo manual",
    "dashboard.Limpeza": "Limpieza",
    "dashboard.Porta": "Puerta",
    "dashboard.Erros e alertas": "Errores y alertas",
    "dashboard.Parâmetros": "Parámetros",
    "dashboard.SEM DADOS POR AQUI" : "NO HAY DATOS AQUÍ",
    "dashboard.AINDA SEM GRÁFICOS POR AQUI" : "AÚN NO HAY GRÁFICOS AQUÍ",
    "dashboard.description.AINDA SEM GRÁFICOS POR AQUI" : "Seleccione elementos de la lista de al lado para generar gráficos o haga clic en la fila para ver más detalles.",
    "dashboard.sem avisos por aqui" : "SIN AVISOS POR AQUÍ",
    
    //INFORMAÇÕES IOK
    "iokInformation.search.placeholder" : "Buscar artículo",
    "iokInformation.article.openInHelpCenter": "Ver artículo en el Centro de ayuda",
    "iokInformation.aboutPlatform.platformFeatures.title": "La plataforma y sus funcionalidades",
    "iokInformation.aboutPlatform.platformFeatures.linkLabel": "Descargar presentación completa",
    "iokInformation.aboutPlatform.manual.title": "Manual de instrucciones",
    "iokInformation.aboutPlatform.manual.linkLabel": "Descargar manual",
    "iokInformation.aboutPlatform.privacy.title": "Política de privacidad",
    "iokInformation.aboutPlatform.privacy.linkLabel": "Descargar política",
    "iokInformation.aboutPlatform.api.title": "API externa",
    "iokInformation.aboutPlatform.api.linkLabel": "Descargar documento",
    
    //Telemetry TSI
    "telemetry.EQUIPMENT_TURN_ON": "Equipo encendido",
    "telemetry.SENSORS_VALUES": "Valores de sensores",
    "telemetry.ERROR_DETECTED": "Error detectado",
    "telemetry.TIME_ADDED": "Tiempo añadido",
    "telemetry.GN_ADDED": "GN añadida",
    "telemetry.GN_RELEASED": "GN iniciada",
    "telemetry.GN_FINISHED": "GN finalizada",
    
    "telemetry.HEAVY_CLEANING_CANCELED": "Limpieza intensiva cancelada",
    "telemetry.CLEANING_CANCELED": "Limpieza cancelada",
    "telemetry.CLEANING_RESTARTED": "Limpieza reiniciada",
    "telemetry.CLEANING_VAPORIZATION_STEP": "Paso de vaporización en limpieza",
    "telemetry.CLEANING_SUPPLY_STEP": "Paso de suministro en limpieza",
    "telemetry.CLEANING_CIRCULATION_STEP": "Paso de circulación en limpieza",
    "telemetry.CLEANING_DEPLETION_STEP": "Paso de vaciado en limpieza",
    "telemetry.CLEANING_RISING_STEP": "Paso de aclarado en limpieza",
    "telemetry.CLEANING_STARTED": "Limpieza iniciada",
    "telemetry.CLEANING_FINISHED": "Limpieza finalizada",
    "telemetry.RECOMMENDED_CLEANING": "Limpieza recomendada",
    "telemetry.VALID_PASSWORD_CLEANING": "Contraseña válida en limpieza",
    "telemetry.INVALID_PASSWORD_CLEANING": "Contraseña inválida en limpieza",
    
    "telemetry.RECIPE_STARTED": "Receta iniciada",
    "telemetry.RECIPE_FINISHED": "Receta finalizada",
    "telemetry.RECIPE_CANCELED": "Receta cancelada",
    "telemetry.RECIPE_STEP_CHANGED": "Paso de receta cambiado",
    "telemetry.RECIPE_PAUSED": "Receta pausada",
    "telemetry.RECIPE_RESUMED": "Receta reanudada",
    "telemetry.RESUME_RECIPE_CANCELED": "Reanudación de receta cancelada",
    "telemetry.DROP_ENERGY_SUPPLY": "Reanudación tras corte de energía",
    
    "telemetry.PRE_HEAT_STARTED": "Precalentamiento iniciado",
    "telemetry.PRE_HEAT_FINISHED": "Precalentamiento finalizado",
    "telemetry.OPERATION_CONTINUE_STARTED": "Reanudación de operación iniciada",
    "telemetry.OPERATION_CONTINUE_FINISHED": "Reanudación de operación finalizada",
    "telemetry.HOLD_TEMPERATURE_STARTED": "Mantenimiento de temperatura iniciado",
    "telemetry.HOLD_TEMPERATURE_FINISHED": "Mantenimiento de temperatura finalizado",
    "telemetry.COOL_DOWN_STARTED": "Enfriamiento iniciado",
    "telemetry.COOL_DOWN_FINISHED": "Enfriamiento finalizado",
    "telemetry.NOCTURNAL_COOKING_STARTED": "Cocción nocturna iniciada",
    "telemetry.NOCTURNAL_COOKING_FINISHED": "Cocción nocturna finalizada",
    "telemetry.SEALING_STARTED": "Sellado iniciado",
    "telemetry.SEALING_FINISHED": "Sellado finalizado",
    "telemetry.TURBO_GRILL_STARTED": "Turbo Grill iniciado",
    "telemetry.TURBO_GRILL_FINISHED": "Turbo Grill finalizado",
    "telemetry.TURBO_GRILL_ACTIVATED": "Turbo Grill activado",
    "telemetry.TURBO_GRILL_DISABLED": "Turbo Grill desactivado",
    
    "telemetry.MOISTURE_CHANGED": "Humedad modificada",
    "telemetry.TURBINE_CHANGED": "Valor de turbina modificado",
    "telemetry.SET_POINT_CHANGED": "Temperatura de cámara modificada",
    "telemetry.STEAM_CHANGED": "Vapor modificado",
    "telemetry.PROBE_CHANGED": "Temperatura de sonda modificada",
    "telemetry.TIME_CHANGED": "Tiempo modificado",
    "telemetry.DOOR_OPENED": "Puerta abierta",
    "telemetry.DOOR_CLOSED": "Puerta cerrada",
    
    "telemetry.PROBE_CONTROL_SELECTED": "Control por sonda seleccionado",
    "telemetry.TIME_CONTROL_SELECTED": "Control por tiempo seleccionado",
    "telemetry.MANUAL_STEAM_INJECTED": "Inyección manual de vapor",
    "telemetry.AUTOMATIC_STEAM_INJECTED": "Inyección automática de vapor",
    
    "telemetry.DATABASE_CREATED": "Base de datos creada",
    "telemetry.EXIT_FUNCTION": "Función finalizada",
    "telemetry.CONSUMPTION": "Consumo",
    "telemetry.STANDBY": "Standby",
    
    "telemetry.ANALYTICS_ERROR_BAD_REQUEST": "Error analytics: Solicitud incorrecta",
    "telemetry.ANALYTICS_ERROR_FORBIDDEN": "Error analytics: Acceso denegado",
    "telemetry.ANALYTICS_ERROR_SERVER": "Error analytics: Fallo en el servidor",
    "telemetry.ANALYTICS_ERROR_UNEXPECTED": "Error analytics: Inesperado",
    "telemetry.ANALYTICS_SUCCESS": "Éxito analytics",
    
    "telemetry.STEP": "Paso",
    "telemetry.STEAM": "Vapor",
    "telemetry.PROBE": "Sonda",
    "telemetry.TURBINE": "Turbina",
    "telemetry.OCCURRENCES": "ocurrencia(s)",
    "telemetry.FUNC_USER_RECIPE": "Receta de Usuario",
    "telemetry.FUNC_TSI_RECIPE": "Receta TSi",
    "telemetry.FUNC_DELTA_T": "Delta T",
    "telemetry.FUNC_STEAM": "Vapor",
    "telemetry.FUNC_COMBINED_STEAM": "Vapor combinado",
    "telemetry.FUNC_HOT_AIR": "Aire caliente",
    "telemetry.FUNC_NOCTURNAL_COOKING": "Cocción nocturna",
    "telemetry.FUNC_REGENERATE": "Regenerar",
    "telemetry.FUNC_MULTIPLE_COOKING": "Cocción múltiple",
    
    "haccp.filterBy": "Filtrar por",
    "haccp.voltage": "Tensión",
    "haccp.voltageReading": "Lectura de tensión",
    "haccp.voltageOscillation": "Oscilación de tensión durante el día",
    "haccp.status.normal": "Normal",
    "haccp.status.attention": "Atención",
    "haccp.status.critical": "Crítico",
    "haccp.dateTime": "Fecha/Hora",
    "haccp.errorDetected": "Error/Alerta detectado",
    "haccp.detected": "detectado",
    "haccp.errorTypeLabel": "Tipo de error/alerta",
    "haccp.severityLabel": "Gravedad",
    "haccp.severity.error": "Error",
    "haccp.severity.alert": "Alerta",
    "haccp.error.canNetwork": "Error red CAN",
    "haccp.error.chamberSensor": "Error sensor de cámara",
    "haccp.error.steamSensor": "Error sensor de vapor",
    "haccp.error.probeSensor": "Error sonda",
    "haccp.error.noWater": "Error falta de agua",
    "haccp.error.panelTemp": "Error temp. panel",
    "haccp.error.motor": "Error motor",
    "haccp.error.motorComm": "Error com. motor",
    "haccp.error.hygieneIncomplete": "Error hig. incompleta",
    "haccp.error.familyModel": "Error familia/modelo",
    "haccp.error.boardTemp": "Error temp. placa",
    "haccp.error.energyModule": "Error mód. energía",
    "haccp.error.i2c": "Error I2C",
    "haccp.error.gas": "Error gas",
    "haccp.export.generating": "La planilla HACCP se está generando y se descargará automáticamente en breve.",
    "haccp.loading": "Cargando...",
    "haccp.quantity": "Cantidad",
    "haccp.executions": "Preparaciones",
    "haccp.manual.mode": "Modo",
    "haccp.manual.tempC": "Temp (°C)",
    "haccp.manual.timeMin": "Tiempo (min)",
    "haccp.manual.probeC": "Sonda (°C)",
    "haccp.manual.steamPct": "Vapor %",
    "haccp.cleaning.label": "Limpieza",
    "haccp.cleaning.recommendedLabel": "Limpieza recomendada",
    "haccp.cleaning.status.completed": "Completada",
    "haccp.cleaning.status.restarted": "Reiniciada",
    "haccp.cleaning.status.interrupted": "Interrumpida",
    "haccp.status.label": "Estado",
    "haccp.error": "Error",
    "haccp.consumption.water": "Consumo de agua",
    "haccp.consumption.energy": "Consumo de energía",
    "haccp.short.temp": "Temp",
    "haccp.short.time": "Tiempo",
    "haccp.day": "Día",
    "haccp.recipeExecutions": "Nº de preparaciones",
    "STEAM": "Vapor",
    "COMBINED_STEAM": "Vapor combinado",
    "PROBE": "Sonda",
    "TURBINE": "Turbina",
    "HOT_AIR": "Aire caliente",
    "NOCTURNAL_COOKING": "Cocción nocturna",
    "REGENERATE": "Regeneración",
    "MULTIPLE_COOKING": "Cocción múltiple",
    "DELTA_T": "Delta T",
    
    //CSAT
    "csat.AVALIE SUA EXPERIÊNCIA": "EVALÚE SU EXPERIENCIA",
    "csat.Como você avalia sua experiência com": "¿Cómo evalúa su experiencia con",
    "csat.Muito insatisfeito": "Muy insatisfecho",
    "csat.Insatisfeito": "Insatisfecho",
    "csat.Neutro": "Neutral",
    "csat.Satisfeito": "Satisfecho",
    "csat.Muito satisfeito": "Muy satisfecho",
    "csat.Utilize o espaço abaixo para deixar suas sugestões:": "Utilice el espacio a continuación para dejar sus sugerencias:",
    "csat.Digite aqui": "Escriba aquí",
    "csat.Obrigado por responder à nossa pesquisa!": "¡Gracias por responder nuestra encuesta!",
    "csat.Selecione uma nota para continuar": "Seleccione una calificación para continuar",
    "csat.Enviar": "Enviar",
    "csat.a criação de receitas": "la creación de recetas",
    "csat.o cadastro de equipamentos": "el registro de equipos",
    "csat.o cadastro de usuários": "el registro de usuarios",
    "csat.a criação de menus": "la creación de menús",
    "csat.a deleção de receitas": "la eliminación de recetas",
    "csat.a reordenação de receitas": "la reorganización de recetas",
    "csat.o envio de software": "el envío de software",
    "csat.o envio de menus": "el envío de menús",
    "csat.o uso de receitas do Cookbook": "el uso de recetas del Cookbook",
  },
};

export default es;

